// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/og-var.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

/* Experiment Level Table Error */
div,section,header,main,p,span,button,h2,form,svg,path,g,footer,input,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}
.about-strand{
   box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */ 
}
::before,
::after {
  --tw-content: '';
}
.custom-component::before,
.custom-component::after {
  box-sizing: border-box; /* 1 */
  border-width: 0;        /* 2 */
  border-style: solid;     /* 2 */
  border-color: #e5e7eb;   /* 2 */
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  /* 3 */
  tab-size: 4;
  /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 4 */
  font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
  -webkit-tap-highlight-color: transparent;
  /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
 
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-feature-settings: normal;
  /* 2 */
  font-variation-settings: normal;
  /* 3 */
  font-size: 1em;
  /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  letter-spacing: inherit;
  /* 1 */
  color: black;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
 
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

.pointer-events-none {
  pointer-events: none;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.inset-0 {
  inset: 0px;
}

.inset-y-0 {
  top: 0px;
  bottom: 0px;
}

.-top-\\[\\.35vw\\] {
  top: -.35vw;
}

.bottom-0 {
  bottom: 0px;
}

.left-0 {
  left: 0px;
}

.left-\\[6\\%\\] {
  left: 6%;
}

.left-full {
  left: 100%;
}

.right-0 {
  right: 0px;
}

.right-\\[2vw\\] {
  right: 2vw;
}

.right-\\[5\\%\\] {
  right: 5%;
}

.top-0 {
  top: 0px;
}

.top-1\\/2 {
  top: 50%;
}

.top-\\[19\\%\\] {
  top: 19%;
}

.top-\\[2vw\\] {
  top: 2vw;
}

.top-\\[45\\%\\] {
  top: 45%;
}

.top-full {
  top: 100%;
}

.right-\\[1vw\\] {
  right: 1vw;
}

.top-\\[1vw\\] {
  top: 1vw;
}

.right-\\[\\.5vw\\] {
  right: .5vw;
}

.top-\\[\\.5vw\\] {
  top: .5vw;
}

.z-0 {
  z-index: 0;
}

.z-30 {
  z-index: 30;
}

.z-50 {
  z-index: 50;
}

.z-\\[0\\] {
  z-index: 0;
}

.z-\\[1\\] {
  z-index: 1;
}

.z-\\[3\\] {
  z-index: 3;
}

.z-\\[5\\] {
  z-index: 5;
}

.z-\\[999\\] {
  z-index: 999;
}

.z-\\[99\\] {
  z-index: 99;
}

.col-start-2 {
  grid-column-start: 2;
}

.col-start-3 {
  grid-column-start: 3;
}

.row-start-2 {
  grid-row-start: 2;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-\\[20vw\\] {
  margin-top: 20vw;
  margin-bottom: 20vw;
}

.my-\\[40vw\\] {
  margin-top: 40vw;
  margin-bottom: 40vw;
}

.mb-\\[2vw\\] {
  margin-bottom: 2vw;
}

.ml-3 {
  margin-left: 0.75rem;
}

.ml-\\[\\.25vw\\] {
  margin-left: .25vw;
}

.ml-auto {
  margin-left: auto;
}

.mt-\\[1\\.8vw\\] {
  margin-top: 1.8vw;
}

.mt-\\[10vw\\] {
  margin-top: 10vw;
}

.mt-\\[12vw\\] {
  margin-top: 12vw;
}

.mt-\\[17\\.5vw\\] {
  margin-top: 17.5vw;
}

.mt-\\[1vw\\] {
  margin-top: 1vw;
}

.mt-\\[22\\.5vw\\] {
  margin-top: 22.5vw;
}

.mt-\\[2vw\\] {
  margin-top: 2vw;
}

.mt-\\[3vw\\] {
  margin-top: 3vw;
}

.mt-\\[5vw\\] {
  margin-top: 5vw;
}

.mt-\\[6\\.5vw\\] {
  margin-top: 6.5vw;
}

.mt-\\[6vw\\] {
  margin-top: 6vw;
}

.mt-\\[7vw\\] {
  margin-top: 7vw;
}

.mt-\\[8vw\\] {
  margin-top: 8vw;
}

.mt-auto {
  margin-top: auto;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.flex {
  display: flex;
}

.grid {
  display: grid;
}

.hidden {
  display: none;
}

.aspect-\\[16\\/16\\.5\\] {
  aspect-ratio: 16/16.5;
}

.aspect-square {
  aspect-ratio: 1 / 1;
}

.h-\\[\\.5vw\\] {
  height: .5vw;
}

.h-\\[1\\.5px\\] {
  height: 1.5px;
}

.h-\\[100dvh\\] {
  height: 100dvh;
}

.h-\\[10vw\\] {
  height: 10vw;
}

.h-\\[2\\.5px\\] {
  height: 2.5px;
}

.h-\\[2\\.65vw\\] {
  height: 2.65vw;
}

.h-\\[240vw\\] {
  height: 240vw;
}

.h-\\[2px\\] {
  height: 2px;
}

.h-\\[3\\.5vw\\] {
  height: 3.5vw;
}

.h-\\[37vw\\] {
  height: 37vw;
}

.h-\\[4vw\\] {
  height: 4vw;
}

.h-\\[7vw\\] {
  height: 7vw;
}

.h-\\[9vw\\] {
  height: 9vw;
}

.h-\\[calc\\(100\\%-2\\.5vw\\)\\] {
  height: calc(100% - 2.5vw);
}

.h-\\[calc\\(100\\%-4\\.5vw\\)\\] {
  height: calc(100% - 4.5vw);
}

.h-auto {
  height: auto;
}

.h-full {
  height: 100%;
}

.h-\\[50vw\\] {
  height: 50vw;
}

.h-\\[45vw\\] {
  height: 45vw;
}

.w-\\[\\.5vw\\] {
  width: .5vw;
}

.w-\\[1\\.05vw\\] {
  width: 1.05vw;
}

.w-\\[1\\.15vw\\] {
  width: 1.15vw;
}

.w-\\[1\\.5vw\\] {
  width: 1.5vw;
}

.w-\\[10vw\\] {
  width: 10vw;
}

.w-\\[12vw\\] {
  width: 12vw;
}

.w-\\[15\\.5vw\\] {
  width: 15.5vw;
}

.w-\\[15vw\\] {
  width: 15vw;
}

.w-\\[20vw\\] {
  width: 20vw;
}

.w-\\[25vw\\] {
  width: 25vw;
}

.w-\\[2vw\\] {
  width: 2vw;
}

.w-\\[30vw\\] {
  width: 30vw;
}

.w-\\[35vw\\] {
  width: 35vw;
}

.w-\\[36\\.8vw\\] {
  width: 36.8vw;
}

.w-\\[3vw\\] {
  width: 3vw;
}

.w-\\[45\\.5\\%\\] {
  width: 45.5%;
}

.w-\\[4vw\\] {
  width: 4vw;
}

.w-\\[5\\.5vw\\] {
  width: 5.5vw;
}

.w-\\[50vw\\] {
  width: 50vw;
}

.w-\\[6vw\\] {
  width: 6vw;
}

.w-\\[78vw\\] {
  width: 78vw;
}

.w-\\[7vw\\] {
  width: 7vw;
}

.w-\\[80\\%\\] {
  width: 80%;
}

.w-\\[8vw\\] {
  width: 8vw;
}

.w-\\[90\\%\\] {
  width: 90%;
}

.w-\\[90vw\\] {
  width: 90vw;
}

.w-auto {
  width: auto;
}

.w-full {
  width: 100%;
}

.w-max {
  width: max-content;
}

.w-screen {
  width: 100vw;
}

.w-\\[80vw\\] {
  width: 80vw;
}

.max-w-\\[90\\%\\] {
  max-width: 90%;
}

.max-w-full {
  max-width: 100%;
}

.max-w-md {
  max-width: 28rem;
}

.flex-1 {
  flex: 1 1;
}

.shrink-0 {
  flex-shrink: 0;
}

.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-x-\\[1vw\\] {
  --tw-translate-x: -1vw;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-x-\\[60\\%\\] {
  --tw-translate-x: -60%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-\\[1vw\\] {
  --tw-translate-y: -1vw;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-\\[20\\%\\] {
  --tw-translate-y: -20%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-\\[35\\%\\] {
  --tw-translate-y: -35%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-1\\/4 {
  --tw-translate-x: 25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-\\[40\\%\\] {
  --tw-translate-y: 40%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-\\[135deg\\] {
  --tw-rotate: 135deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-\\[90deg\\] {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.cursor-pointer {
  cursor: pointer;
}

.select-none {
  -webkit-user-select: none;
          user-select: none;
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.flex-col {
  flex-direction: column;
}

.flex-col-reverse {
  flex-direction: column-reverse;
}

.place-content-center {
  place-content: center;
}

.\\!items-start {
  align-items: flex-start !important;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.items-baseline {
  align-items: baseline;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-\\[\\.25vw\\] {
  gap: .25vw;
}

.gap-\\[\\.5vw\\] {
  gap: .5vw;
}

.gap-\\[1\\.5vw\\] {
  gap: 1.5vw;
}

.gap-\\[15vw\\] {
  gap: 15vw;
}

.gap-\\[1vw\\] {
  gap: 1vw;
}

.gap-\\[2\\.25vw\\] {
  gap: 2.25vw;
}

.gap-\\[20vw\\] {
  gap: 20vw;
}

.gap-\\[2vw\\] {
  gap: 2vw;
}

.gap-\\[3vw\\] {
  gap: 3vw;
}

.gap-\\[4vw\\] {
  gap: 4vw;
}

.gap-\\[5vw\\] {
  gap: 5vw;
}

.gap-\\[8vw\\] {
  gap: 8vw;
}

.space-y-\\[1vw\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1vw * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1vw * var(--tw-space-y-reverse));
}

.space-y-\\[2\\.5vw\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5vw * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5vw * var(--tw-space-y-reverse));
}

.space-y-\\[4vw\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(4vw * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(4vw * var(--tw-space-y-reverse));
}

.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}

.divide-\\[\\#090B0A\\]\\/\\[\\.28\\] > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(9 11 10 / .28);
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.overflow-y-scroll {
  overflow-y: scroll;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.rounded-\\[2vw\\] {
  border-radius: 2vw;
}

.rounded-\\[3vw\\] {
  border-radius: 3vw;
}

.rounded-\\[4vw\\] {
  border-radius: 4vw;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-md {
  border-radius: 0.375rem;
}

.border {
  border-width: 1px;
}

.border-\\[\\.75px\\] {
  border-width: .75px;
}

.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-b-\\[1\\.5px\\] {
  border-bottom-width: 1.5px;
}

.border-l {
  border-left-width: 1px;
}

.border-t {
  border-top-width: 1px;
}

.border-\\[\\#090B0A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(9 11 10 / var(--tw-border-opacity));
}

.border-\\[\\#191919\\] {
  --tw-border-opacity: 1;
  border-color: rgb(25 25 25 / var(--tw-border-opacity));
}

.border-\\[\\#484543\\] {
  --tw-border-opacity: 1;
  border-color: rgb(72 69 67 / var(--tw-border-opacity));
}

.border-\\[\\#A8A8A8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(168 168 168 / var(--tw-border-opacity));
}

.border-\\[\\#E5E5E5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 229 229 / var(--tw-border-opacity));
}

.border-\\[\\#EBA78C\\] {
  --tw-border-opacity: 1;
  border-color: rgb(235 167 140 / var(--tw-border-opacity));
}

.border-\\[\\#F14234\\] {
  --tw-border-opacity: 1;
  border-color: rgb(241 66 52 / var(--tw-border-opacity));
}

.border-\\[\\#FFFFFF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.border-neutral-100\\/70 {
  border-color: rgb(245 245 245 / 0.7);
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.bg-\\[\\#090B0A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(9 11 10 / var(--tw-bg-opacity));
}

.bg-\\[\\#171717\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity));
}

.bg-\\[\\#191919\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(25 25 25 / var(--tw-bg-opacity));
}

.bg-\\[\\#1D1D1D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
}

.bg-\\[\\#272727\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 39 / var(--tw-bg-opacity));
}

.bg-\\[\\#E7EDF2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 237 242 / var(--tw-bg-opacity));
}

.bg-\\[\\#E7F1F3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 241 243 / var(--tw-bg-opacity));
}

.bg-\\[\\#EFE7F3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 231 243 / var(--tw-bg-opacity));
}

.bg-\\[\\#F14234\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 66 52 / var(--tw-bg-opacity));
}

.bg-\\[\\#F24134\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 65 52 / var(--tw-bg-opacity));
}

.bg-\\[\\#F7F4FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 244 255 / var(--tw-bg-opacity));
}

.bg-\\[\\#F7F7F7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}

.bg-\\[\\#FAFAFA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}

.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-\\[white\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-default {
  --tw-bg-opacity: 1;
  background-color: #364098;
}

.bg-transparent {
  background-color: transparent;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-opacity-10 {
  --tw-bg-opacity: 0.1;
}

.p-\\[2vw\\] {
  padding: 2vw;
}

.p-\\[5\\.25vw\\] {
  padding: 5.25vw;
}

.p-\\[5vw\\] {
  padding: 5vw;
}

.px-\\[1vw\\] {
  padding-left: 1vw;
  padding-right: 1vw;
}

.px-\\[2vw\\] {
  padding-left: 2vw;
  padding-right: 2vw;
}

.px-\\[3vw\\] {
  padding-left: 3vw;
  padding-right: 3vw;
}

.px-\\[4vw\\] {
  padding-left: 4vw;
  padding-right: 4vw;
}

.px-\\[5\\.25vw\\] {
  padding-left: 5.25vw;
  padding-right: 5.25vw;
}

.px-\\[5vw\\] {
  padding-left: 5vw;
  padding-right: 5vw;
}

.px-\\[7vw\\] {
  padding-left: 7vw;
  padding-right: 7vw;
}

.px-\\[8vw\\] {
  padding-left: 8vw;
  padding-right: 8vw;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.py-\\[\\.5vw\\] {
  padding-top: .5vw;
  padding-bottom: .5vw;
}

.py-\\[\\.65vw\\] {
  padding-top: .65vw;
  padding-bottom: .65vw;
}

.py-\\[\\.75vw\\] {
  padding-top: .75vw;
  padding-bottom: .75vw;
}

.py-\\[1\\.75vw\\] {
  padding-top: 1.75vw;
  padding-bottom: 1.75vw;
}

.py-\\[10vw\\] {
  padding-top: 10vw;
  padding-bottom: 10vw;
}

.py-\\[15vw\\] {
  padding-top: 15vw;
  padding-bottom: 15vw;
}

.py-\\[1vw\\] {
  padding-top: 1vw;
  padding-bottom: 1vw;
}

.py-\\[2\\.5vw\\] {
  padding-top: 2.5vw;
  padding-bottom: 2.5vw;
}

.py-\\[2vw\\] {
  padding-top: 2vw;
  padding-bottom: 2vw;
}

.py-\\[3\\.5vw\\] {
  padding-top: 3.5vw;
  padding-bottom: 3.5vw;
}

.py-\\[5vw\\] {
  padding-top: 5vw;
  padding-bottom: 5vw;
}

.py-\\[8vw\\] {
  padding-top: 8vw;
  padding-bottom: 8vw;
}

.pb-\\[\\.35vw\\] {
  padding-bottom: .35vw;
}

.pb-\\[10vw\\] {
  padding-bottom: 10vw;
}

.pb-\\[15vw\\] {
  padding-bottom: 15vw;
}

.pb-\\[2\\.5vw\\] {
  padding-bottom: 2.5vw;
}

.pb-\\[3\\.5vw\\] {
  padding-bottom: 3.5vw;
}

.pb-\\[4vw\\] {
  padding-bottom: 4vw;
}

.pb-\\[5vw\\] {
  padding-bottom: 5vw;
}

.pb-\\[6vw\\] {
  padding-bottom: 6vw;
}

.pb-\\[7vw\\] {
  padding-bottom: 7vw;
}

.pl-10 {
  padding-left: 2.5rem;
}

.pl-\\[\\.5vw\\] {
  padding-left: .5vw;
}

.pl-\\[10vw\\] {
  padding-left: 10vw;
}

.pl-\\[3vw\\] {
  padding-left: 3vw;
}

.pl-\\[4vw\\] {
  padding-left: 4vw;
}

.pl-\\[5\\.25vw\\] {
  padding-left: 5.25vw;
}

.pl-\\[5\\.5vw\\] {
  padding-left: 5.5vw;
}

.pl-\\[5vw\\] {
  padding-left: 5vw;
}

.pl-\\[7vw\\] {
  padding-left: 7vw;
}

.pr-\\[3vw\\] {
  padding-right: 3vw;
}

.pr-\\[4\\.5vw\\] {
  padding-right: 4.5vw;
}

.pr-\\[5\\.25vw\\] {
  padding-right: 5.25vw;
}

.pr-\\[7vw\\] {
  padding-right: 7vw;
}

.pt-\\[10vw\\] {
  padding-top: 10vw;
}

.pt-\\[1vw\\] {
  padding-top: 1vw;
}

.pt-\\[2\\.5vw\\] {
  padding-top: 2.5vw;
}

.pt-\\[3vw\\] {
  padding-top: 3vw;
}

.pt-\\[4vw\\] {
  padding-top: 4vw;
}

.pt-\\[5vw\\] {
  padding-top: 5vw;
}

.pt-\\[6vw\\] {
  padding-top: 6vw;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-\\[1\\.05vw\\] {
  font-size: 1.05vw;
}

.text-\\[10vw\\] {
  font-size: 10vw;
}

.text-\\[11vw\\] {
  font-size: 11vw;
}

.text-\\[13\\.5vw\\] {
  font-size: 13.5vw;
}

.text-\\[3\\.05vw\\] {
  font-size: 3.05vw;
}

.text-\\[3\\.15vw\\] {
  font-size: 3.15vw;
}

.text-\\[3\\.25vw\\] {
  font-size: 3.25vw;
}

.text-\\[3\\.5vw\\] {
  font-size: 3.5vw;
}

.text-\\[3\\.65vw\\] {
  font-size: 3.65vw;
}

.text-\\[3\\.75vw\\] {
  font-size: 3.75vw;
}

.text-\\[3\\.85vw\\] {
  font-size: 3.85vw;
}

.text-\\[3vw\\] {
  font-size: 3vw;
}

.text-\\[4vw\\] {
  font-size: 4vw;
}

.text-\\[5vw\\] {
  font-size: 5vw;
}

.text-\\[6vw\\] {
  font-size: 6vw;
}

.text-\\[8vw\\] {
  font-size: 8vw;
}

.text-\\[9\\.3vw\\] {
  font-size: 9.3vw;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.font-\\[325\\] {
  font-weight: 325;
}

.font-\\[350\\] {
  font-weight: 350;
}

.font-\\[450\\] {
  font-weight: 450;
}

.font-\\[500\\] {
  font-weight: 500;
}

.font-\\[550\\] {
  font-weight: 550;
}

.font-light {
  font-weight: 300;
}

.font-medium {
  font-weight: 500;
}

.font-normal {
  font-weight: 400;
}

.font-semibold {
  font-weight: 600;
}

.leading-6 {
  line-height: 1.5rem;
}

.leading-\\[\\.875\\] {
  line-height: .875;
}

.leading-\\[\\.95\\] {
  line-height: .95;
}

.leading-\\[1\\.09\\] {
  line-height: 1.09;
}

.leading-\\[1\\.1\\] {
  line-height: 1.1;
}

.leading-\\[1\\.2\\] {
  line-height: 1.2;
}

.leading-\\[1\\.3\\] {
  line-height: 1.3;
}

.leading-\\[1\\.4\\] {
  line-height: 1.4;
}

.leading-\\[1\\.5\\] {
  line-height: 1.5;
}

.leading-\\[1\\] {
  line-height: 1;
}

.tracking-tight {
  letter-spacing: -0.025em;
}

.text-\\[\\#090B0A\\] {
  --tw-text-opacity: 1;
  color: rgb(9 11 10 / var(--tw-text-opacity));
}

.text-\\[\\#191818\\] {
  --tw-text-opacity: 1;
  color: rgb(25 24 24 / var(--tw-text-opacity));
}

.text-\\[\\#191919\\] {
  --tw-text-opacity: 1;
  color: rgb(25 25 25 / var(--tw-text-opacity));
}

.text-\\[\\#1D1D1D\\] {
  --tw-text-opacity: 1;
  color: rgb(29 29 29 / var(--tw-text-opacity));
}

.text-\\[\\#242424\\] {
  --tw-text-opacity: 1;
  color: rgb(36 36 36 / var(--tw-text-opacity));
}

.text-\\[\\#2B2929\\] {
  --tw-text-opacity: 1;
  color: rgb(43 41 41 / var(--tw-text-opacity));
}

.text-\\[\\#363535\\] {
  --tw-text-opacity: 1;
  color: rgb(54 53 53 / var(--tw-text-opacity));
}

.text-\\[\\#433D83\\] {
  --tw-text-opacity: 1;
  color: rgb(67 61 131 / var(--tw-text-opacity));
}

.text-\\[\\#F14234\\] {
  --tw-text-opacity: 1;
  color: rgb(241 66 52 / var(--tw-text-opacity));
}

.text-\\[\\#F24134\\] {
  --tw-text-opacity: 1;
  color: rgb(242 65 52 / var(--tw-text-opacity));
}

.text-\\[\\#FFFFFF\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-\\[\\#ffffff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.text-neutral-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.underline {
  text-decoration-line: underline;
}

.opacity-0 {
  opacity: 0;
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-300 {
  transition-duration: 300ms;
}

.duration-500 {
  transition-duration: 500ms;
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@font-face {
  font-family: "Overused Grotesk";

  font-style: normal;

  font-display: swap;

  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

.font-og {
  font-family: "Overused Grotesk";
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.accordion-content.active {
  overflow: visible;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
  z-index: 99;
}

.modal-background {
  position: absolute;
  inset: 0;
  z-index: 10;
}

.modal-content {
  position: relative;
  z-index: 11;
  background: white;
  transform: translateY(50px);
  opacity: 0;
  transition: all 0.3s;
}

.modal-overlay-visible {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.1);
  opacity: 1; 
  pointer-events: auto; 
  z-index: 99;
}


.modal-content-visible {
  position: relative;
  z-index: 11; 
  background: white;
  transform: translateY(0); 
  opacity: 1; 
  transition: all 0.3s; 
}

.modal-overlay.show .modal-content {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.modal-overlay.show {
  opacity: 1;
  pointer-events: auto;
}

.nav-bar {
  position: relative;
  z-index: 100; 
  background-color: white; 
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); 
}

.flipSvg > div > svg {
  transform: rotate(180deg);
  transition-duration: 400ms;
}

.placeholder\\:text-\\[3\\.5vw\\]::placeholder {
  font-size: 3.5vw;
}

.focus-within\\:border-black:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.hover\\:bg-neutral-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}

.focus\\:border-0:focus {
  border-width: 0px;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}


.group:hover .group-hover\\:pointer-events-auto {
  pointer-events: auto;
}

.group\\/first:hover .group-hover\\/first\\:pointer-events-auto {
  pointer-events: auto;
}

.group\\/second:hover .group-hover\\/second\\:pointer-events-auto {
  pointer-events: auto;
}

.group\\/third:hover .group-hover\\/third\\:pointer-events-auto {
  pointer-events: auto;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group\\/first:hover .group-hover\\/first\\:opacity-100 {
  opacity: 1;
}

.group\\/second:hover .group-hover\\/second\\:opacity-100 {
  opacity: 1;
}

.group\\/third:hover .group-hover\\/third\\:opacity-100 {
  opacity: 1;
}

.submenu {
  display: none;
}

.submenu.active {
  display: block;
  padding-left: 20px;
}

.submenu-item:hover {
  background-color: #742626;
  cursor: pointer;
}

.submenu {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  opacity: 0;
  transform: translateY(-10px);
}

.submenu.active {
  opacity: 1;
  transform: translateY(0);
}

.relative {
  position: relative;
}

button {
  cursor: pointer;
}

.pointer-events-auto {
  pointer-events: auto;
}

.opacity-100 {
  opacity: 1;
}

.inline-block {
  display: inline-block;
  padding: 0.5vw 1vw;
}

.hover\\:bg-gray-50:hover {
  background-color: #d3c3c3;
}

@media (min-width: 640px) {
  .sm\\:duration-700 {
    transition-duration: 700ms;
  }
}


  .md\\:space-y-\\[\\.35vw\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(.35vw * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(.35vw * var(--tw-space-y-reverse));
  }

  .md\\:space-y-\\[1\\.25vw\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25vw * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25vw * var(--tw-space-y-reverse));
  }

  .md\\:space-y-\\[1\\.75vw\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.75vw * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.75vw * var(--tw-space-y-reverse));
  }

  .md\\:rounded-\\[\\.5vw\\] {
    border-radius: .5vw;
  }

  .md\\:rounded-\\[\\.85vw\\] {
    border-radius: .85vw;
  }

  .md\\:rounded-\\[1\\.5vw\\] {
    border-radius: 1.5vw;
  }

  .md\\:border-b-\\[1\\.5px\\] {
    border-bottom-width: 1.5px;
  }

  .md\\:bg-\\[\\#F7F4FF\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(247 244 255 / var(--tw-bg-opacity));
  }

  .md\\:p-\\[1\\.5vw\\] {
    padding: 1.5vw;
  }

  .md\\:p-\\[1vw\\] {
    padding: 1vw;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-\\[\\.75vw\\] {
    padding-left: .75vw;
    padding-right: .75vw;
  }

  .md\\:px-\\[1\\.25vw\\] {
    padding-left: 1.25vw;
    padding-right: 1.25vw;
  }

  .md\\:px-\\[1\\.5vw\\] {
    padding-left: 1.5vw;
    padding-right: 1.5vw;
  }

  .md\\:px-\\[1vw\\] {
    padding-left: 1vw;
    padding-right: 1vw;
  }

  .md\\:px-\\[2\\.5vw\\] {
    padding-left: 2.5vw;
    padding-right: 2.5vw;
  }

  .md\\:px-\\[2vw\\] {
    padding-left: 2vw;
    padding-right: 2vw;
  }

  .md\\:px-\\[3\\.2vw\\] {
    padding-left: 3.2vw;
    padding-right: 3.2vw;
  }

  .md\\:px-\\[5\\.25vw\\] {
    padding-left: 5.25vw;
    padding-right: 5.25vw;
  }

  .md\\:py-\\[\\.2vw\\] {
    padding-top: .2vw;
    padding-bottom: .2vw;
  }

  .md\\:py-\\[\\.65vw\\] {
    padding-top: .65vw;
    padding-bottom: .65vw;
  }

  .md\\:py-\\[\\.75vw\\] {
    padding-top: .75vw;
    padding-bottom: .75vw;
  }

  .md\\:py-\\[1vw\\] {
    padding-top: 1vw;
    padding-bottom: 1vw;
  }

  .md\\:py-\\[2\\.5vw\\] {
    padding-top: 2.5vw;
    padding-bottom: 2.5vw;
  }

  .md\\:py-\\[4\\.5vw\\] {
    padding-top: 4.5vw;
    padding-bottom: 4.5vw;
  }

  .md\\:py-\\[5\\.25vw\\] {
    padding-top: 5.25vw;
    padding-bottom: 5.25vw;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pb-\\[\\.5vw\\] {
    padding-bottom: .5vw;
  }

  .md\\:pb-\\[1\\.5vw\\] {
    padding-bottom: 1.5vw;
  }

  .md\\:pb-\\[11vw\\] {
    padding-bottom: 11vw;
  }

  .md\\:pb-\\[2\\.25vw\\] {
    padding-bottom: 2.25vw;
  }

  .md\\:pb-\\[2vw\\] {
    padding-bottom: 2vw;
  }

  .md\\:pb-\\[3\\.5vw\\] {
    padding-bottom: 3.5vw;
  }

  .md\\:pb-\\[4vw\\] {
    padding-bottom: 4vw;
  }

  .md\\:pb-\\[5vw\\] {
    padding-bottom: 5vw;
  }

  .md\\:pb-\\[8vw\\] {
    padding-bottom: 8vw;
  }

  .md\\:pl-0 {
    padding-left: 0px;
  }

  .md\\:pl-\\[10vw\\] {
    padding-left: 10vw;
  }

  .md\\:pl-\\[25vw\\] {
    padding-left: 25vw;
  }

  .md\\:pl-\\[3vw\\] {
    padding-left: 3vw;
  }

  .md\\:pl-\\[9\\.25vw\\] {
    padding-left: 9.25vw;
  }

  .md\\:pr-0 {
    padding-right: 0px;
  }

  .md\\:pr-\\[2vw\\] {
    padding-right: 2vw;
  }

  .md\\:pr-\\[7vw\\] {
    padding-right: 7vw;
  }

  .md\\:pr-\\[8vw\\] {
    padding-right: 8vw;
  }

  .md\\:pt-\\[\\.8vw\\] {
    padding-top: .8vw;
  }

  .md\\:pt-\\[0vw\\] {
    padding-top: 0vw;
  }

  .md\\:pt-\\[1\\.25vw\\] {
    padding-top: 1.25vw;
  }

  .md\\:pt-\\[13\\.5vw\\] {
    padding-top: 13.5vw;
  }

  .md\\:pt-\\[1vw\\] {
    padding-top: 1vw;
  }

  .md\\:pt-\\[2\\.5vw\\] {
    padding-top: 2.5vw;
  }

  .md\\:pt-\\[3vw\\] {
    padding-top: 3vw;
  }

  .md\\:pt-\\[4\\.5vw\\] {
    padding-top: 4.5vw;
  }

  .md\\:pt-\\[5vw\\] {
    padding-top: 5vw;
  }

  .md\\:pt-\\[7vw\\] {
    padding-top: 7vw;
  }

  .md\\:text-\\[\\.85vw\\] {
    font-size: .85vw;
  }

  .md\\:text-\\[\\.8vw\\] {
    font-size: .8vw;
  }

  .md\\:text-\\[1\\.01vw\\] {
    font-size: 1.01vw;
  }

  .md\\:text-\\[1\\.05vw\\] {
    font-size: 1.05vw;
  }

  .md\\:text-\\[1\\.15vw\\] {
    font-size: 1.15vw;
  }

  .md\\:text-\\[1\\.1vw\\] {
    font-size: 1.1vw;
  }

  .md\\:text-\\[1\\.235vw\\] {
    font-size: 1.235vw;
  }

  .md\\:text-\\[1\\.2vw\\] {
    font-size: 1.2vw;
  }

  .md\\:text-\\[1\\.30vw\\] {
    font-size: 1.30vw;
  }

  .md\\:text-\\[1\\.3vw\\] {
    font-size: 1.3vw;
  }

  .md\\:text-\\[1\\.55vw\\] {
    font-size: 1.55vw;
  }

  .md\\:text-\\[1\\.5vw\\] {
    font-size: 1.5vw;
  }

  .md\\:text-\\[1vw\\] {
    font-size: 1vw;
  }

  .md\\:text-\\[2\\.5vw\\] {
    font-size: 2.5vw;
  }

  .md\\:text-\\[2\\.7vw\\] {
    font-size: 2.7vw;
  }

  .md\\:text-\\[3\\.5vw\\] {
    font-size: 3.5vw;
  }

  .md\\:text-\\[4\\.5vw\\] {
    font-size: 4.5vw;
  }

  .md\\:text-\\[5\\.8vw\\] {
    font-size: 5.8vw;
  }

  .md\\:text-\\[5\\.9vw\\] {
    font-size: 5.9vw;
  }

  .md\\:text-\\[8\\.15vw\\] {
    font-size: 8.15vw;
  }

  .md\\:leading-\\[\\.92\\] {
    line-height: .92;
  }

  .md\\:leading-\\[1\\.2\\] {
    line-height: 1.2;
  }

  .md\\:leading-\\[1\\.3\\] {
    line-height: 1.3;
  }

  .md\\:leading-normal {
    line-height: 1.5;
  }

  .md\\:placeholder\\:text-\\[1\\.01vw\\]::placeholder {
    font-size: 1.01vw;
  }

  .md\\:placeholder\\:text-\\[1\\.235vw\\]::placeholder {
    font-size: 1.235vw;
  }


@media (min-width: 768px) {
  .md\\:absolute {
    position: absolute;
  }

  .md\\:right-\\[1vw\\] {
    right: 1vw;
  }

  .md\\:top-0 {
    top: 0px;
  }

  .md\\:top-\\[1vw\\] {
    top: 1vw;
  }

  .md\\:my-\\[1vw\\] {
    margin-top: 1vw;
    margin-bottom: 1vw;
  }

  .md\\:my-\\[2vw\\] {
    margin-top: 2vw;
    margin-bottom: 2vw;
  }

  .md\\:mb-\\[\\.9vw\\] {
    margin-bottom: .9vw;
  }

  .md\\:mb-\\[1\\.5vw\\] {
    margin-bottom: 1.5vw;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-\\[-6vw\\] {
    margin-top: -6vw;
  }

  .md\\:mt-\\[\\.45vw\\] {
    margin-top: .45vw;
  }

  .md\\:mt-\\[1vw\\] {
    margin-top: 1vw;
  }

  .md\\:mt-\\[2\\.5vw\\] {
    margin-top: 2.5vw;
  }

  .md\\:mt-\\[2vw\\] {
    margin-top: 2vw;
  }

  .md\\:mt-\\[3vw\\] {
    margin-top: 3vw;
  }

  .md\\:mt-\\[4vw\\] {
    margin-top: 4vw;
  }

  .md\\:mt-\\[6vw\\] {
    margin-top: 6vw;
  }

  .md\\:mt-\\[7vw\\] {
    margin-top: 7vw;
  }

  .md\\:mt-auto {
    margin-top: auto;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline-block {
    display: inline-block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-\\[\\.18vw\\] {
    height: .18vw;
  }

  .md\\:h-\\[1\\.55vw\\] {
    height: 1.55vw;
  }

  .md\\:h-\\[1\\.75vw\\] {
    height: 1.75vw;
  }

  .md\\:h-\\[2\\.25vw\\] {
    height: 2.25vw;
  }

  .md\\:h-\\[2\\.5px\\] {
    height: 2.5px;
  }

  .md\\:h-\\[2\\.65vw\\] {
    height: 2.65vw;
  }

  .md\\:h-\\[22vw\\] {
    height: 22vw;
  }

  .md\\:h-\\[3\\.5vw\\] {
    height: 3.5vw;
  }

  .md\\:h-\\[4\\.25vw\\] {
    height: 4.25vw;
  }

  .md\\:max-h-\\[35vh\\] {
    max-height: 35vh;
  }

  .md\\:w-\\[\\.75vw\\] {
    width: .75vw;
  }

  .md\\:w-\\[\\.85vw\\] {
    width: .85vw;
  }

  .md\\:w-\\[\\.8vw\\] {
    width: .8vw;
  }

  .md\\:w-\\[1\\.05vw\\] {
    width: 1.05vw;
  }

  .md\\:w-\\[1\\.25vw\\] {
    width: 1.25vw;
  }

  .md\\:w-\\[1\\.45vw\\] {
    width: 1.45vw;
  }

  .md\\:w-\\[1\\.5vw\\] {
    width: 1.5vw;
  }

  .md\\:w-\\[10\\.8vw\\] {
    width: 10.8vw;
  }

  .md\\:w-\\[10vw\\] {
    width: 10vw;
  }

  .md\\:w-\\[11\\.5vw\\] {
    width: 11.5vw;
  }

  .md\\:w-\\[12vw\\] {
    width: 12vw;
  }

  .md\\:w-\\[1vw\\] {
    width: 1vw;
  }

  .md\\:w-\\[2\\.75vw\\] {
    width: 2.75vw;
  }

  .md\\:w-\\[20\\.5vw\\] {
    width: 20.5vw;
  }

  .md\\:w-\\[26vw\\] {
    width: 26vw;
  }

  .md\\:w-\\[2vw\\] {
    width: 2vw;
  }

  .md\\:w-\\[3\\.5vw\\] {
    width: 3.5vw;
  }

  .md\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .md\\:w-\\[32vw\\] {
    width: 32vw;
  }

  .md\\:w-\\[36\\%\\] {
    width: 36%;
  }

  .md\\:w-\\[37vw\\] {
    width: 37vw;
  }

  .md\\:w-\\[38\\%\\] {
    width: 38%;
  }

  .md\\:w-\\[4\\.25vw\\] {
    width: 4.25vw;
  }

  .md\\:w-\\[4\\.75vw\\] {
    width: 4.75vw;
  }

  .md\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .md\\:w-\\[4vw\\] {
    width: 4vw;
  }

  .md\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .md\\:w-\\[58\\%\\] {
    width: 58%;
  }

  .md\\:w-\\[5vw\\] {
    width: 5vw;
  }

  .md\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .md\\:w-\\[62\\%\\] {
    width: 62%;
  }

  .md\\:w-\\[65\\%\\] {
    width: 65%;
  }

  .md\\:w-\\[7\\.25vw\\] {
    width: 7.25vw;
  }

  .md\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .md\\:w-\\[75\\%\\] {
    width: 75%;
  }

  .md\\:w-\\[78\\%\\] {
    width: 78%;
  }

  .md\\:w-\\[85\\%\\] {
    width: 85%;
  }

  .md\\:w-\\[88\\%\\] {
    width: 88%;
  }

  .md\\:w-\\[8vw\\] {
    width: 8vw;
  }

  .md\\:-translate-y-\\[15\\%\\] {
    --tw-translate-y: -15%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-0 {
    gap: 0px;
  }

  .md\\:gap-\\[\\.5vw\\] {
    gap: .5vw;
  }

  .md\\:gap-\\[\\.75vw\\] {
    gap: .75vw;
  }

  .md\\:gap-\\[\\.8vw\\] {
    gap: .8vw;
  }

  .md\\:gap-\\[1\\.5vw\\] {
    gap: 1.5vw;
  }

  .md\\:gap-\\[1\\.75vw\\] {
    gap: 1.75vw;
  }

  .md\\:gap-\\[1\\.85vw\\] {
    gap: 1.85vw;
  }

  .md\\:gap-\\[10vw\\] {
    gap: 10vw;
  }

  .md\\:gap-\\[1vw\\] {
    gap: 1vw;
  }

  .md\\:gap-\\[2vw\\] {
    gap: 2vw;
  }

  .md\\:gap-\\[3\\.5vw\\] {
    gap: 3.5vw;
  }

  .md\\:space-y-\\[\\.35vw\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(.35vw * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(.35vw * var(--tw-space-y-reverse));
  }

  .md\\:space-y-\\[1\\.25vw\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25vw * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25vw * var(--tw-space-y-reverse));
  }

  .md\\:space-y-\\[1\\.75vw\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.75vw * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.75vw * var(--tw-space-y-reverse));
  }

  .md\\:rounded-\\[\\.5vw\\] {
    border-radius: .5vw;
  }

  .md\\:rounded-\\[\\.85vw\\] {
    border-radius: .85vw;
  }

  .md\\:rounded-\\[1\\.5vw\\] {
    border-radius: 1.5vw;
  }

  .md\\:border-b-\\[1\\.5px\\] {
    border-bottom-width: 1.5px;
  }

  .md\\:bg-\\[\\#F7F4FF\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(247 244 255 / var(--tw-bg-opacity));
  }

  .md\\:p-\\[1\\.5vw\\] {
    padding: 1.5vw;
  }

  .md\\:p-\\[1vw\\] {
    padding: 1vw;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-\\[\\.75vw\\] {
    padding-left: .75vw;
    padding-right: .75vw;
  }

  .md\\:px-\\[1\\.25vw\\] {
    padding-left: 1.25vw;
    padding-right: 1.25vw;
  }

  .md\\:px-\\[1\\.5vw\\] {
    padding-left: 1.5vw;
    padding-right: 1.5vw;
  }

  .md\\:px-\\[1vw\\] {
    padding-left: 1vw;
    padding-right: 1vw;
  }

  .md\\:px-\\[2\\.5vw\\] {
    padding-left: 2.5vw;
    padding-right: 2.5vw;
  }

  .md\\:px-\\[2vw\\] {
    padding-left: 2vw;
    padding-right: 2vw;
  }

  .md\\:px-\\[3\\.2vw\\] {
    padding-left: 3.2vw;
    padding-right: 3.2vw;
  }

  .md\\:px-\\[5\\.25vw\\] {
    padding-left: 5.25vw;
    padding-right: 5.25vw;
  }

  .md\\:py-\\[\\.2vw\\] {
    padding-top: .2vw;
    padding-bottom: .2vw;
  }

  .md\\:py-\\[\\.65vw\\] {
    padding-top: .65vw;
    padding-bottom: .65vw;
  }

  .md\\:py-\\[\\.75vw\\] {
    padding-top: .75vw;
    padding-bottom: .75vw;
  }

  .md\\:py-\\[1vw\\] {
    padding-top: 1vw;
    padding-bottom: 1vw;
  }

  .md\\:py-\\[2\\.5vw\\] {
    padding-top: 2.5vw;
    padding-bottom: 2.5vw;
  }

  .md\\:py-\\[4\\.5vw\\] {
    padding-top: 4.5vw;
    padding-bottom: 4.5vw;
  }

  .md\\:py-\\[5\\.25vw\\] {
    padding-top: 5.25vw;
    padding-bottom: 5.25vw;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pb-\\[\\.5vw\\] {
    padding-bottom: .5vw;
  }

  .md\\:pb-\\[1\\.5vw\\] {
    padding-bottom: 1.5vw;
  }

  .md\\:pb-\\[11vw\\] {
    padding-bottom: 11vw;
  }

  .md\\:pb-\\[19vw\\] {
    padding-bottom: 19vw;
  }

  .md\\:pb-\\[2\\.25vw\\] {
    padding-bottom: 2.25vw;
  }

  .md\\:pb-\\[2vw\\] {
    padding-bottom: 2vw;
  }

  .md\\:pb-\\[3\\.5vw\\] {
    padding-bottom: 3.5vw;
  }

  .md\\:pb-\\[4vw\\] {
    padding-bottom: 4vw;
  }

  .md\\:pb-\\[5vw\\] {
    padding-bottom: 5vw;
  }

  .md\\:pb-\\[8vw\\] {
    padding-bottom: 8vw;
  }

  .md\\:pl-0 {
    padding-left: 0px;
  }

  .md\\:pl-\\[10vw\\] {
    padding-left: 10vw;
  }

  .md\\:pl-\\[25vw\\] {
    padding-left: 25vw;
  }

  .md\\:pl-\\[3vw\\] {
    padding-left: 3vw;
  }

  .md\\:pl-\\[9\\.25vw\\] {
    padding-left: 9.25vw;
  }

  .md\\:pr-0 {
    padding-right: 0px;
  }

  .md\\:pr-\\[2vw\\] {
    padding-right: 2vw;
  }

  .md\\:pr-\\[7vw\\] {
    padding-right: 7vw;
  }

  .md\\:pr-\\[8vw\\] {
    padding-right: 8vw;
  }

  .md\\:pt-\\[\\.8vw\\] {
    padding-top: .8vw;
  }

  .md\\:pt-\\[0vw\\] {
    padding-top: 0vw;
  }

  .md\\:pt-\\[1\\.25vw\\] {
    padding-top: 1.25vw;
  }

  .md\\:pt-\\[13\\.5vw\\] {
    padding-top: 13.5vw;
  }

  .md\\:pt-\\[1vw\\] {
    padding-top: 1vw;
  }

  .md\\:pt-\\[2\\.5vw\\] {
    padding-top: 2.5vw;
  }

  .md\\:pt-\\[3vw\\] {
    padding-top: 3vw;
  }

  .md\\:pt-\\[4\\.5vw\\] {
    padding-top: 4.5vw;
  }

  .md\\:pt-\\[5vw\\] {
    padding-top: 5vw;
  }

  .md\\:pt-\\[7vw\\] {
    padding-top: 7vw;
  }

  .md\\:text-\\[\\.85vw\\] {
    font-size: .85vw;
  }

  .md\\:text-\\[\\.8vw\\] {
    font-size: .8vw;
  }

  .md\\:text-\\[1\\.01vw\\] {
    font-size: 1.01vw;
  }

  .md\\:text-\\[1\\.05vw\\] {
    font-size: 1.05vw;
  }

  .md\\:text-\\[1\\.15vw\\] {
    font-size: 1.15vw;
  }

  .md\\:text-\\[1\\.1vw\\] {
    font-size: 1.1vw;
  }

  .md\\:text-\\[1\\.235vw\\] {
    font-size: 1.235vw;
  }

  .md\\:text-\\[1\\.2vw\\] {
    font-size: 1.2vw;
  }

  .md\\:text-\\[1\\.30vw\\] {
    font-size: 1.30vw;
  }

  .md\\:text-\\[1\\.3vw\\] {
    font-size: 1.3vw;
  }

  .md\\:text-\\[1\\.55vw\\] {
    font-size: 1.55vw;
  }

  .md\\:text-\\[1\\.5vw\\] {
    font-size: 1.5vw;
  }

  .md\\:text-\\[1vw\\] {
    font-size: 1vw;
  }

  .md\\:text-\\[2\\.5vw\\] {
    font-size: 2.5vw;
  }

  .md\\:text-\\[2\\.7vw\\] {
    font-size: 2.7vw;
  }

  .md\\:text-\\[3\\.5vw\\] {
    font-size: 3.5vw;
  }

  .md\\:text-\\[3vw\\] {
    font-size: 3vw;
  }

  .md\\:text-\\[4\\.5vw\\] {
    font-size: 4.5vw;
  }

  .md\\:text-\\[5\\.8vw\\] {
    font-size: 5.8vw;
  }

  .md\\:text-\\[5\\.9vw\\] {
    font-size: 5.9vw;
  }

  .md\\:text-\\[8\\.15vw\\] {
    font-size: 8.15vw;
  }

  .md\\:leading-\\[\\.92\\] {
    line-height: .92;
  }

  .md\\:leading-\\[1\\.2\\] {
    line-height: 1.2;
  }

  .md\\:leading-\\[1\\.3\\] {
    line-height: 1.3;
  }

  .md\\:leading-normal {
    line-height: 1.5;
  }

  .md\\:placeholder\\:text-\\[1\\.01vw\\]::placeholder {
    font-size: 1.01vw;
  }

  .md\\:placeholder\\:text-\\[1\\.235vw\\]::placeholder {
    font-size: 1.235vw;
  }
}

@media (min-width: 1024px) {
  .lg\\:max-h-\\[90vh\\] {
    max-height: 90vh;
  }

  .lg\\:min-h-screen {
    min-height: 100vh;
  }

  .lg\\:pb-\\[12vw\\] {
    padding-bottom: 12vw;
  }
}

.pb-\\[3vw\\] {
  padding-bottom: 3vw;
}
.bg-\\[\\#F7F7F7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}
.overflow-y-scroll {
  overflow-y: scroll;
}

.sticky {
  position: sticky;
}
.border-\\[\\#090B0A\\]\\/\\[\\.28\\] {
  border-color: rgb(9 11 10 / .28);
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/assets/css/output.css"],"names":[],"mappings":";AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;CAEC;;AAED;;;CAGC;;AAED,iCAAiC;AACjC;;;EAGE,sBAAsB;EACtB,MAAM;EACN,eAAe;EACf,MAAM;EACN,mBAAmB;EACnB,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;AACA;GACG,sBAAsB;EACvB,MAAM;EACN,eAAe;EACf,MAAM;EACN,mBAAmB;EACnB,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,sBAAsB,EAAE,MAAM;EAC9B,eAAe,SAAS,MAAM;EAC9B,mBAAmB,MAAM,MAAM;EAC/B,qBAAqB,IAAI,MAAM;AACjC;;AAEA;;;;;;;;CAQC;;AAED;;EAEE,gBAAgB;EAChB,MAAM;EACN,8BAA8B;EAC9B,MAAM;EAEN,MAAM;EAEH,WAAW;EACd,MAAM;EACN,+HAA+H;EAC/H,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,+BAA+B;EAC/B,MAAM;EACN,wCAAwC;EACxC,MAAM;AACR;;AAEA;;;CAGC;;AAED;;EAEE,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;;;CAIC;;AAED;EACE,SAAS;EACT,MAAM;EACN,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,yCAAyC;UACjC,iCAAiC;AAC3C;;AAEA;;CAEC;;AAED;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;CAEC;;AAED;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,mBAAmB;AACrB;;AAEA;;;;;CAKC;;AAED;;;;EAIE,+GAA+G;EAC/G,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,+BAA+B;EAC/B,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,cAAc;AAChB;;AAEA;;CAEC;;AAED;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;EACN,yBAAyB;EACzB,MAAM;AACR;;AAEA;;;;CAIC;;AAED;;;;;EAKE,oBAAoB;EACpB,MAAM;EACN,8BAA8B;EAC9B,MAAM;EACN,gCAAgC;EAChC,MAAM;EACN,eAAe;EACf,MAAM;EACN,oBAAoB;EACpB,MAAM;EACN,oBAAoB;EACpB,MAAM;EACN,uBAAuB;EACvB,MAAM;EACN,YAAY;EACZ,MAAM;EACN,SAAS;EACT,MAAM;EACN,UAAU;EACV,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,oBAAoB;AACtB;;AAEA;;;CAGC;;AAED;;;;EAIE,0BAA0B;EAC1B,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,aAAa;AACf;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,YAAY;AACd;;AAEA;;;CAGC;;AAED;EACE,6BAA6B;EAC7B,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;;CAGC;;AAED;EACE,0BAA0B;EAC1B,MAAM;EACN,aAAa;EACb,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,kBAAkB;AACpB;;AAEA;;CAEC;;AAED;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;;CAGC;;AASD;;EAEE,UAAU;EACV,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,eAAe;AACjB;;AAEA;;CAEC;;AAED;EACE,eAAe;AACjB;;AAEA;;;;CAIC;;AAED;;;;;;;;;EASE,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA,wEAAwE;;AAExE;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,qBAAqB;EACrB,+LAA+L;AACjM;;AAEA;EACE,qBAAqB;EACrB,+LAA+L;AACjM;;AAEA;EACE,qBAAqB;EACrB,+LAA+L;AACjM;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,qBAAqB;EACrB,+LAA+L;AACjM;;AAEA;EACE,qBAAqB;EACrB,+LAA+L;AACjM;;AAEA;EACE,kBAAkB;EAClB,+LAA+L;AACjM;;AAEA;EACE,kBAAkB;EAClB,+LAA+L;AACjM;;AAEA;EACE,mBAAmB;EACnB,+LAA+L;AACjM;;AAEA;EACE,kBAAkB;EAClB,+LAA+L;AACjM;;AAEA;EACE,+LAA+L;AACjM;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;UAEjB,iBAAiB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,2DAA2D;EAC3D,oDAAoD;AACtD;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,sDAAsD;AACxD;;AAEA;EACE,uBAAuB;EACvB,2DAA2D;EAC3D,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,kEAAkE;EAClE,2DAA2D;AAC7D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;AACrD;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0EAA0E;EAC1E,8FAA8F;EAC9F,uGAAuG;AACzG;;AAEA;EACE,+EAA+E;EAC/E,mGAAmG;EACnG,uGAAuG;AACzG;;AAEA;EACE,iLAAiL;AACnL;;AAEA;EAEE,wJAAwJ;EAExJ,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,+BAA+B;;EAE/B,kBAAkB;;EAElB,kBAAkB;;EAElB,+DAAkD;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;EACpB,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAMA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;AAC9F;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gEAAgE;EAChE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;;EAGE;IACE,uBAAuB;IACvB,6DAA6D;IAC7D,sDAAsD;EACxD;;EAEA;IACE,uBAAuB;IACvB,8DAA8D;IAC9D,uDAAuD;EACzD;;EAEA;IACE,uBAAuB;IACvB,8DAA8D;IAC9D,uDAAuD;EACzD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,yDAAyD;EAC3D;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAMA;IACE,iBAAiB;EACnB;;EAMA;IACE,kBAAkB;EACpB;;;AAGF;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,+LAA+L;EACjM;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,6DAA6D;IAC7D,sDAAsD;EACxD;;EAEA;IACE,uBAAuB;IACvB,8DAA8D;IAC9D,uDAAuD;EACzD;;EAEA;IACE,uBAAuB;IACvB,8DAA8D;IAC9D,uDAAuD;EACzD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,yDAAyD;EAC3D;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAMA;IACE,iBAAiB;EACnB;;EAMA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B","sourcesContent":["\n*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  ;\n}\n\n/*\n! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com\n*/\n\n/*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n/* Experiment Level Table Error */\ndiv,section,header,main,p,span,button,h2,form,svg,path,g,footer,input,\n::before,\n::after {\n  box-sizing: border-box;\n  /* 1 */\n  border-width: 0;\n  /* 2 */\n  border-style: solid;\n  /* 2 */\n  border-color: #e5e7eb;\n  /* 2 */\n}\n.about-strand{\n   box-sizing: border-box;\n  /* 1 */\n  border-width: 0;\n  /* 2 */\n  border-style: solid;\n  /* 2 */\n  border-color: #e5e7eb;\n  /* 2 */ \n}\n::before,\n::after {\n  --tw-content: '';\n}\n.custom-component::before,\n.custom-component::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0;        /* 2 */\n  border-style: solid;     /* 2 */\n  border-color: #e5e7eb;   /* 2 */\n}\n\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n7. Disable tap highlights on iOS\n*/\n\nhtml,\n:host {\n  line-height: 1.5;\n  /* 1 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n  -moz-tab-size: 4;\n  /* 3 */\n  -o-tab-size: 4;\n     tab-size: 4;\n  /* 3 */\n  font-family: ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  /* 4 */\n  font-feature-settings: normal;\n  /* 5 */\n  font-variation-settings: normal;\n  /* 6 */\n  -webkit-tap-highlight-color: transparent;\n  /* 7 */\n}\n\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n \n  /* 1 */\n  line-height: inherit;\n  /* 2 */\n}\n\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\n\nhr {\n  height: 0;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  border-top-width: 1px;\n  /* 3 */\n}\n\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n\n/*\nRemove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n1. Use the user's configured `mono` font-family by default.\n2. Use the user's configured `mono` font-feature-settings by default.\n3. Use the user's configured `mono` font-variation-settings by default.\n4. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  /* 1 */\n  font-feature-settings: normal;\n  /* 2 */\n  font-variation-settings: normal;\n  /* 3 */\n  font-size: 1em;\n  /* 4 */\n}\n\n/*\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0;\n  /* 1 */\n  border-color: inherit;\n  /* 2 */\n  border-collapse: collapse;\n  /* 3 */\n}\n\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  /* 1 */\n  font-feature-settings: inherit;\n  /* 1 */\n  font-variation-settings: inherit;\n  /* 1 */\n  font-size: 100%;\n  /* 1 */\n  font-weight: inherit;\n  /* 1 */\n  line-height: inherit;\n  /* 1 */\n  letter-spacing: inherit;\n  /* 1 */\n  color: black;\n  /* 1 */\n  margin: 0;\n  /* 2 */\n  padding: 0;\n  /* 3 */\n}\n\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\n\nbutton,\ninput:where([type='button']),\ninput:where([type='reset']),\ninput:where([type='submit']) {\n  -webkit-appearance: button;\n  /* 1 */\n  background-color: transparent;\n  /* 2 */\n  background-image: none;\n  /* 2 */\n}\n\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nReset default styling for dialogs.\n*/\n\ndialog {\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\n\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n \n  /* 1 */\n  vertical-align: middle;\n  /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n\n[hidden]:where(:not([hidden=\"until-found\"])) {\n  display: none;\n}\n\n.pointer-events-none {\n  pointer-events: none;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.inset-0 {\n  inset: 0px;\n}\n\n.inset-y-0 {\n  top: 0px;\n  bottom: 0px;\n}\n\n.-top-\\[\\.35vw\\] {\n  top: -.35vw;\n}\n\n.bottom-0 {\n  bottom: 0px;\n}\n\n.left-0 {\n  left: 0px;\n}\n\n.left-\\[6\\%\\] {\n  left: 6%;\n}\n\n.left-full {\n  left: 100%;\n}\n\n.right-0 {\n  right: 0px;\n}\n\n.right-\\[2vw\\] {\n  right: 2vw;\n}\n\n.right-\\[5\\%\\] {\n  right: 5%;\n}\n\n.top-0 {\n  top: 0px;\n}\n\n.top-1\\/2 {\n  top: 50%;\n}\n\n.top-\\[19\\%\\] {\n  top: 19%;\n}\n\n.top-\\[2vw\\] {\n  top: 2vw;\n}\n\n.top-\\[45\\%\\] {\n  top: 45%;\n}\n\n.top-full {\n  top: 100%;\n}\n\n.right-\\[1vw\\] {\n  right: 1vw;\n}\n\n.top-\\[1vw\\] {\n  top: 1vw;\n}\n\n.right-\\[\\.5vw\\] {\n  right: .5vw;\n}\n\n.top-\\[\\.5vw\\] {\n  top: .5vw;\n}\n\n.z-0 {\n  z-index: 0;\n}\n\n.z-30 {\n  z-index: 30;\n}\n\n.z-50 {\n  z-index: 50;\n}\n\n.z-\\[0\\] {\n  z-index: 0;\n}\n\n.z-\\[1\\] {\n  z-index: 1;\n}\n\n.z-\\[3\\] {\n  z-index: 3;\n}\n\n.z-\\[5\\] {\n  z-index: 5;\n}\n\n.z-\\[999\\] {\n  z-index: 999;\n}\n\n.z-\\[99\\] {\n  z-index: 99;\n}\n\n.col-start-2 {\n  grid-column-start: 2;\n}\n\n.col-start-3 {\n  grid-column-start: 3;\n}\n\n.row-start-2 {\n  grid-row-start: 2;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.my-\\[20vw\\] {\n  margin-top: 20vw;\n  margin-bottom: 20vw;\n}\n\n.my-\\[40vw\\] {\n  margin-top: 40vw;\n  margin-bottom: 40vw;\n}\n\n.mb-\\[2vw\\] {\n  margin-bottom: 2vw;\n}\n\n.ml-3 {\n  margin-left: 0.75rem;\n}\n\n.ml-\\[\\.25vw\\] {\n  margin-left: .25vw;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n.mt-\\[1\\.8vw\\] {\n  margin-top: 1.8vw;\n}\n\n.mt-\\[10vw\\] {\n  margin-top: 10vw;\n}\n\n.mt-\\[12vw\\] {\n  margin-top: 12vw;\n}\n\n.mt-\\[17\\.5vw\\] {\n  margin-top: 17.5vw;\n}\n\n.mt-\\[1vw\\] {\n  margin-top: 1vw;\n}\n\n.mt-\\[22\\.5vw\\] {\n  margin-top: 22.5vw;\n}\n\n.mt-\\[2vw\\] {\n  margin-top: 2vw;\n}\n\n.mt-\\[3vw\\] {\n  margin-top: 3vw;\n}\n\n.mt-\\[5vw\\] {\n  margin-top: 5vw;\n}\n\n.mt-\\[6\\.5vw\\] {\n  margin-top: 6.5vw;\n}\n\n.mt-\\[6vw\\] {\n  margin-top: 6vw;\n}\n\n.mt-\\[7vw\\] {\n  margin-top: 7vw;\n}\n\n.mt-\\[8vw\\] {\n  margin-top: 8vw;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.block {\n  display: block;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\n.flex {\n  display: flex;\n}\n\n.grid {\n  display: grid;\n}\n\n.hidden {\n  display: none;\n}\n\n.aspect-\\[16\\/16\\.5\\] {\n  aspect-ratio: 16/16.5;\n}\n\n.aspect-square {\n  aspect-ratio: 1 / 1;\n}\n\n.h-\\[\\.5vw\\] {\n  height: .5vw;\n}\n\n.h-\\[1\\.5px\\] {\n  height: 1.5px;\n}\n\n.h-\\[100dvh\\] {\n  height: 100dvh;\n}\n\n.h-\\[10vw\\] {\n  height: 10vw;\n}\n\n.h-\\[2\\.5px\\] {\n  height: 2.5px;\n}\n\n.h-\\[2\\.65vw\\] {\n  height: 2.65vw;\n}\n\n.h-\\[240vw\\] {\n  height: 240vw;\n}\n\n.h-\\[2px\\] {\n  height: 2px;\n}\n\n.h-\\[3\\.5vw\\] {\n  height: 3.5vw;\n}\n\n.h-\\[37vw\\] {\n  height: 37vw;\n}\n\n.h-\\[4vw\\] {\n  height: 4vw;\n}\n\n.h-\\[7vw\\] {\n  height: 7vw;\n}\n\n.h-\\[9vw\\] {\n  height: 9vw;\n}\n\n.h-\\[calc\\(100\\%-2\\.5vw\\)\\] {\n  height: calc(100% - 2.5vw);\n}\n\n.h-\\[calc\\(100\\%-4\\.5vw\\)\\] {\n  height: calc(100% - 4.5vw);\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.h-\\[50vw\\] {\n  height: 50vw;\n}\n\n.h-\\[45vw\\] {\n  height: 45vw;\n}\n\n.w-\\[\\.5vw\\] {\n  width: .5vw;\n}\n\n.w-\\[1\\.05vw\\] {\n  width: 1.05vw;\n}\n\n.w-\\[1\\.15vw\\] {\n  width: 1.15vw;\n}\n\n.w-\\[1\\.5vw\\] {\n  width: 1.5vw;\n}\n\n.w-\\[10vw\\] {\n  width: 10vw;\n}\n\n.w-\\[12vw\\] {\n  width: 12vw;\n}\n\n.w-\\[15\\.5vw\\] {\n  width: 15.5vw;\n}\n\n.w-\\[15vw\\] {\n  width: 15vw;\n}\n\n.w-\\[20vw\\] {\n  width: 20vw;\n}\n\n.w-\\[25vw\\] {\n  width: 25vw;\n}\n\n.w-\\[2vw\\] {\n  width: 2vw;\n}\n\n.w-\\[30vw\\] {\n  width: 30vw;\n}\n\n.w-\\[35vw\\] {\n  width: 35vw;\n}\n\n.w-\\[36\\.8vw\\] {\n  width: 36.8vw;\n}\n\n.w-\\[3vw\\] {\n  width: 3vw;\n}\n\n.w-\\[45\\.5\\%\\] {\n  width: 45.5%;\n}\n\n.w-\\[4vw\\] {\n  width: 4vw;\n}\n\n.w-\\[5\\.5vw\\] {\n  width: 5.5vw;\n}\n\n.w-\\[50vw\\] {\n  width: 50vw;\n}\n\n.w-\\[6vw\\] {\n  width: 6vw;\n}\n\n.w-\\[78vw\\] {\n  width: 78vw;\n}\n\n.w-\\[7vw\\] {\n  width: 7vw;\n}\n\n.w-\\[80\\%\\] {\n  width: 80%;\n}\n\n.w-\\[8vw\\] {\n  width: 8vw;\n}\n\n.w-\\[90\\%\\] {\n  width: 90%;\n}\n\n.w-\\[90vw\\] {\n  width: 90vw;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.w-max {\n  width: -moz-max-content;\n  width: max-content;\n}\n\n.w-screen {\n  width: 100vw;\n}\n\n.w-\\[80vw\\] {\n  width: 80vw;\n}\n\n.max-w-\\[90\\%\\] {\n  max-width: 90%;\n}\n\n.max-w-full {\n  max-width: 100%;\n}\n\n.max-w-md {\n  max-width: 28rem;\n}\n\n.flex-1 {\n  flex: 1 1 0%;\n}\n\n.shrink-0 {\n  flex-shrink: 0;\n}\n\n.-translate-x-1\\/2 {\n  --tw-translate-x: -50%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.-translate-x-\\[1vw\\] {\n  --tw-translate-x: -1vw;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.-translate-x-\\[60\\%\\] {\n  --tw-translate-x: -60%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.-translate-y-1\\/2 {\n  --tw-translate-y: -50%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.-translate-y-\\[1vw\\] {\n  --tw-translate-y: -1vw;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.-translate-y-\\[20\\%\\] {\n  --tw-translate-y: -20%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.-translate-y-\\[35\\%\\] {\n  --tw-translate-y: -35%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.translate-x-0 {\n  --tw-translate-x: 0px;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.translate-x-1\\/2 {\n  --tw-translate-x: 50%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.translate-x-1\\/4 {\n  --tw-translate-x: 25%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.translate-x-full {\n  --tw-translate-x: 100%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.translate-y-1\\/2 {\n  --tw-translate-y: 50%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.translate-y-\\[40\\%\\] {\n  --tw-translate-y: 40%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.rotate-45 {\n  --tw-rotate: 45deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.rotate-90 {\n  --tw-rotate: 90deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.rotate-\\[135deg\\] {\n  --tw-rotate: 135deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.rotate-\\[90deg\\] {\n  --tw-rotate: 90deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.transform {\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.select-none {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-col-reverse {\n  flex-direction: column-reverse;\n}\n\n.place-content-center {\n  place-content: center;\n}\n\n.\\!items-start {\n  align-items: flex-start !important;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.items-baseline {\n  align-items: baseline;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.gap-1 {\n  gap: 0.25rem;\n}\n\n.gap-\\[\\.25vw\\] {\n  gap: .25vw;\n}\n\n.gap-\\[\\.5vw\\] {\n  gap: .5vw;\n}\n\n.gap-\\[1\\.5vw\\] {\n  gap: 1.5vw;\n}\n\n.gap-\\[15vw\\] {\n  gap: 15vw;\n}\n\n.gap-\\[1vw\\] {\n  gap: 1vw;\n}\n\n.gap-\\[2\\.25vw\\] {\n  gap: 2.25vw;\n}\n\n.gap-\\[20vw\\] {\n  gap: 20vw;\n}\n\n.gap-\\[2vw\\] {\n  gap: 2vw;\n}\n\n.gap-\\[3vw\\] {\n  gap: 3vw;\n}\n\n.gap-\\[4vw\\] {\n  gap: 4vw;\n}\n\n.gap-\\[5vw\\] {\n  gap: 5vw;\n}\n\n.gap-\\[8vw\\] {\n  gap: 8vw;\n}\n\n.space-y-\\[1vw\\] > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(1vw * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(1vw * var(--tw-space-y-reverse));\n}\n\n.space-y-\\[2\\.5vw\\] > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(2.5vw * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(2.5vw * var(--tw-space-y-reverse));\n}\n\n.space-y-\\[4vw\\] > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(4vw * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(4vw * var(--tw-space-y-reverse));\n}\n\n.divide-y > :not([hidden]) ~ :not([hidden]) {\n  --tw-divide-y-reverse: 0;\n  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));\n  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));\n}\n\n.divide-\\[\\#090B0A\\]\\/\\[\\.28\\] > :not([hidden]) ~ :not([hidden]) {\n  border-color: rgb(9 11 10 / .28);\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll;\n}\n\n.whitespace-nowrap {\n  white-space: nowrap;\n}\n\n.rounded-\\[2vw\\] {\n  border-radius: 2vw;\n}\n\n.rounded-\\[3vw\\] {\n  border-radius: 3vw;\n}\n\n.rounded-\\[4vw\\] {\n  border-radius: 4vw;\n}\n\n.rounded-full {\n  border-radius: 9999px;\n}\n\n.rounded-md {\n  border-radius: 0.375rem;\n}\n\n.border {\n  border-width: 1px;\n}\n\n.border-\\[\\.75px\\] {\n  border-width: .75px;\n}\n\n.border-\\[1\\.5px\\] {\n  border-width: 1.5px;\n}\n\n.border-b {\n  border-bottom-width: 1px;\n}\n\n.border-b-\\[1\\.5px\\] {\n  border-bottom-width: 1.5px;\n}\n\n.border-l {\n  border-left-width: 1px;\n}\n\n.border-t {\n  border-top-width: 1px;\n}\n\n.border-\\[\\#090B0A\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(9 11 10 / var(--tw-border-opacity));\n}\n\n.border-\\[\\#191919\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(25 25 25 / var(--tw-border-opacity));\n}\n\n.border-\\[\\#484543\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(72 69 67 / var(--tw-border-opacity));\n}\n\n.border-\\[\\#A8A8A8\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(168 168 168 / var(--tw-border-opacity));\n}\n\n.border-\\[\\#E5E5E5\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(229 229 229 / var(--tw-border-opacity));\n}\n\n.border-\\[\\#EBA78C\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(235 167 140 / var(--tw-border-opacity));\n}\n\n.border-\\[\\#F14234\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(241 66 52 / var(--tw-border-opacity));\n}\n\n.border-\\[\\#FFFFFF\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(255 255 255 / var(--tw-border-opacity));\n}\n\n.border-black {\n  --tw-border-opacity: 1;\n  border-color: rgb(0 0 0 / var(--tw-border-opacity));\n}\n\n.border-neutral-100\\/70 {\n  border-color: rgb(245 245 245 / 0.7);\n}\n\n.border-white {\n  --tw-border-opacity: 1;\n  border-color: rgb(255 255 255 / var(--tw-border-opacity));\n}\n\n.bg-\\[\\#090B0A\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(9 11 10 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#171717\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(23 23 23 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#191919\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(25 25 25 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#1D1D1D\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(29 29 29 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#272727\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(39 39 39 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#E7EDF2\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(231 237 242 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#E7F1F3\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(231 241 243 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#EFE7F3\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(239 231 243 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#F14234\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(241 66 52 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#F24134\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(242 65 52 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#F7F4FF\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(247 244 255 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#F7F7F7\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(247 247 247 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#FAFAFA\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(250 250 250 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#FFFFFF\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-\\[white\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-black {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity));\n}\n.bg-default {\n  --tw-bg-opacity: 1;\n  background-color: #364098;\n}\n\n.bg-transparent {\n  background-color: transparent;\n}\n\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-opacity-10 {\n  --tw-bg-opacity: 0.1;\n}\n\n.p-\\[2vw\\] {\n  padding: 2vw;\n}\n\n.p-\\[5\\.25vw\\] {\n  padding: 5.25vw;\n}\n\n.p-\\[5vw\\] {\n  padding: 5vw;\n}\n\n.px-\\[1vw\\] {\n  padding-left: 1vw;\n  padding-right: 1vw;\n}\n\n.px-\\[2vw\\] {\n  padding-left: 2vw;\n  padding-right: 2vw;\n}\n\n.px-\\[3vw\\] {\n  padding-left: 3vw;\n  padding-right: 3vw;\n}\n\n.px-\\[4vw\\] {\n  padding-left: 4vw;\n  padding-right: 4vw;\n}\n\n.px-\\[5\\.25vw\\] {\n  padding-left: 5.25vw;\n  padding-right: 5.25vw;\n}\n\n.px-\\[5vw\\] {\n  padding-left: 5vw;\n  padding-right: 5vw;\n}\n\n.px-\\[7vw\\] {\n  padding-left: 7vw;\n  padding-right: 7vw;\n}\n\n.px-\\[8vw\\] {\n  padding-left: 8vw;\n  padding-right: 8vw;\n}\n\n.py-3 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.py-5 {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.py-\\[\\.5vw\\] {\n  padding-top: .5vw;\n  padding-bottom: .5vw;\n}\n\n.py-\\[\\.65vw\\] {\n  padding-top: .65vw;\n  padding-bottom: .65vw;\n}\n\n.py-\\[\\.75vw\\] {\n  padding-top: .75vw;\n  padding-bottom: .75vw;\n}\n\n.py-\\[1\\.75vw\\] {\n  padding-top: 1.75vw;\n  padding-bottom: 1.75vw;\n}\n\n.py-\\[10vw\\] {\n  padding-top: 10vw;\n  padding-bottom: 10vw;\n}\n\n.py-\\[15vw\\] {\n  padding-top: 15vw;\n  padding-bottom: 15vw;\n}\n\n.py-\\[1vw\\] {\n  padding-top: 1vw;\n  padding-bottom: 1vw;\n}\n\n.py-\\[2\\.5vw\\] {\n  padding-top: 2.5vw;\n  padding-bottom: 2.5vw;\n}\n\n.py-\\[2vw\\] {\n  padding-top: 2vw;\n  padding-bottom: 2vw;\n}\n\n.py-\\[3\\.5vw\\] {\n  padding-top: 3.5vw;\n  padding-bottom: 3.5vw;\n}\n\n.py-\\[5vw\\] {\n  padding-top: 5vw;\n  padding-bottom: 5vw;\n}\n\n.py-\\[8vw\\] {\n  padding-top: 8vw;\n  padding-bottom: 8vw;\n}\n\n.pb-\\[\\.35vw\\] {\n  padding-bottom: .35vw;\n}\n\n.pb-\\[10vw\\] {\n  padding-bottom: 10vw;\n}\n\n.pb-\\[15vw\\] {\n  padding-bottom: 15vw;\n}\n\n.pb-\\[2\\.5vw\\] {\n  padding-bottom: 2.5vw;\n}\n\n.pb-\\[3\\.5vw\\] {\n  padding-bottom: 3.5vw;\n}\n\n.pb-\\[4vw\\] {\n  padding-bottom: 4vw;\n}\n\n.pb-\\[5vw\\] {\n  padding-bottom: 5vw;\n}\n\n.pb-\\[6vw\\] {\n  padding-bottom: 6vw;\n}\n\n.pb-\\[7vw\\] {\n  padding-bottom: 7vw;\n}\n\n.pl-10 {\n  padding-left: 2.5rem;\n}\n\n.pl-\\[\\.5vw\\] {\n  padding-left: .5vw;\n}\n\n.pl-\\[10vw\\] {\n  padding-left: 10vw;\n}\n\n.pl-\\[3vw\\] {\n  padding-left: 3vw;\n}\n\n.pl-\\[4vw\\] {\n  padding-left: 4vw;\n}\n\n.pl-\\[5\\.25vw\\] {\n  padding-left: 5.25vw;\n}\n\n.pl-\\[5\\.5vw\\] {\n  padding-left: 5.5vw;\n}\n\n.pl-\\[5vw\\] {\n  padding-left: 5vw;\n}\n\n.pl-\\[7vw\\] {\n  padding-left: 7vw;\n}\n\n.pr-\\[3vw\\] {\n  padding-right: 3vw;\n}\n\n.pr-\\[4\\.5vw\\] {\n  padding-right: 4.5vw;\n}\n\n.pr-\\[5\\.25vw\\] {\n  padding-right: 5.25vw;\n}\n\n.pr-\\[7vw\\] {\n  padding-right: 7vw;\n}\n\n.pt-\\[10vw\\] {\n  padding-top: 10vw;\n}\n\n.pt-\\[1vw\\] {\n  padding-top: 1vw;\n}\n\n.pt-\\[2\\.5vw\\] {\n  padding-top: 2.5vw;\n}\n\n.pt-\\[3vw\\] {\n  padding-top: 3vw;\n}\n\n.pt-\\[4vw\\] {\n  padding-top: 4vw;\n}\n\n.pt-\\[5vw\\] {\n  padding-top: 5vw;\n}\n\n.pt-\\[6vw\\] {\n  padding-top: 6vw;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-\\[1\\.05vw\\] {\n  font-size: 1.05vw;\n}\n\n.text-\\[10vw\\] {\n  font-size: 10vw;\n}\n\n.text-\\[11vw\\] {\n  font-size: 11vw;\n}\n\n.text-\\[13\\.5vw\\] {\n  font-size: 13.5vw;\n}\n\n.text-\\[3\\.05vw\\] {\n  font-size: 3.05vw;\n}\n\n.text-\\[3\\.15vw\\] {\n  font-size: 3.15vw;\n}\n\n.text-\\[3\\.25vw\\] {\n  font-size: 3.25vw;\n}\n\n.text-\\[3\\.5vw\\] {\n  font-size: 3.5vw;\n}\n\n.text-\\[3\\.65vw\\] {\n  font-size: 3.65vw;\n}\n\n.text-\\[3\\.75vw\\] {\n  font-size: 3.75vw;\n}\n\n.text-\\[3\\.85vw\\] {\n  font-size: 3.85vw;\n}\n\n.text-\\[3vw\\] {\n  font-size: 3vw;\n}\n\n.text-\\[4vw\\] {\n  font-size: 4vw;\n}\n\n.text-\\[5vw\\] {\n  font-size: 5vw;\n}\n\n.text-\\[6vw\\] {\n  font-size: 6vw;\n}\n\n.text-\\[8vw\\] {\n  font-size: 8vw;\n}\n\n.text-\\[9\\.3vw\\] {\n  font-size: 9.3vw;\n}\n\n.text-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.font-\\[325\\] {\n  font-weight: 325;\n}\n\n.font-\\[350\\] {\n  font-weight: 350;\n}\n\n.font-\\[450\\] {\n  font-weight: 450;\n}\n\n.font-\\[500\\] {\n  font-weight: 500;\n}\n\n.font-\\[550\\] {\n  font-weight: 550;\n}\n\n.font-light {\n  font-weight: 300;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-normal {\n  font-weight: 400;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.leading-6 {\n  line-height: 1.5rem;\n}\n\n.leading-\\[\\.875\\] {\n  line-height: .875;\n}\n\n.leading-\\[\\.95\\] {\n  line-height: .95;\n}\n\n.leading-\\[1\\.09\\] {\n  line-height: 1.09;\n}\n\n.leading-\\[1\\.1\\] {\n  line-height: 1.1;\n}\n\n.leading-\\[1\\.2\\] {\n  line-height: 1.2;\n}\n\n.leading-\\[1\\.3\\] {\n  line-height: 1.3;\n}\n\n.leading-\\[1\\.4\\] {\n  line-height: 1.4;\n}\n\n.leading-\\[1\\.5\\] {\n  line-height: 1.5;\n}\n\n.leading-\\[1\\] {\n  line-height: 1;\n}\n\n.tracking-tight {\n  letter-spacing: -0.025em;\n}\n\n.text-\\[\\#090B0A\\] {\n  --tw-text-opacity: 1;\n  color: rgb(9 11 10 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#191818\\] {\n  --tw-text-opacity: 1;\n  color: rgb(25 24 24 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#191919\\] {\n  --tw-text-opacity: 1;\n  color: rgb(25 25 25 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#1D1D1D\\] {\n  --tw-text-opacity: 1;\n  color: rgb(29 29 29 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#242424\\] {\n  --tw-text-opacity: 1;\n  color: rgb(36 36 36 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#2B2929\\] {\n  --tw-text-opacity: 1;\n  color: rgb(43 41 41 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#363535\\] {\n  --tw-text-opacity: 1;\n  color: rgb(54 53 53 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#433D83\\] {\n  --tw-text-opacity: 1;\n  color: rgb(67 61 131 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#F14234\\] {\n  --tw-text-opacity: 1;\n  color: rgb(241 66 52 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#F24134\\] {\n  --tw-text-opacity: 1;\n  color: rgb(242 65 52 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#FFFFFF\\] {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.text-\\[\\#ffffff\\] {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.text-gray-900 {\n  --tw-text-opacity: 1;\n  color: rgb(17 24 39 / var(--tw-text-opacity));\n}\n\n.text-neutral-600 {\n  --tw-text-opacity: 1;\n  color: rgb(82 82 82 / var(--tw-text-opacity));\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.underline {\n  text-decoration-line: underline;\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.shadow {\n  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-lg {\n  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n\n.transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.duration-300 {\n  transition-duration: 300ms;\n}\n\n.duration-500 {\n  transition-duration: 500ms;\n}\n\n.ease-in-out {\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@font-face {\n  font-family: \"Overused Grotesk\";\n\n  font-style: normal;\n\n  font-display: swap;\n\n  src: url(\"../fonts/og-var.ttf\") format(\"truetype\");\n}\n\n.font-og {\n  font-family: \"Overused Grotesk\";\n}\n\n.accordion-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n}\n\n.accordion-content.active {\n  overflow: visible;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s;\n  z-index: 99;\n}\n\n.modal-background {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n}\n\n.modal-content {\n  position: relative;\n  z-index: 11;\n  background: white;\n  transform: translateY(50px);\n  opacity: 0;\n  transition: all 0.3s;\n}\n\n.modal-overlay-visible {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.1);\n  opacity: 1; \n  pointer-events: auto; \n  z-index: 99;\n}\n\n\n.modal-content-visible {\n  position: relative;\n  z-index: 11; \n  background: white;\n  transform: translateY(0); \n  opacity: 1; \n  transition: all 0.3s; \n}\n\n.modal-overlay.show .modal-content {\n  transform: translateY(0);\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.modal-overlay.show {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.nav-bar {\n  position: relative;\n  z-index: 100; \n  background-color: white; \n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); \n}\n\n.flipSvg > div > svg {\n  transform: rotate(180deg);\n  transition-duration: 400ms;\n}\n\n.placeholder\\:text-\\[3\\.5vw\\]::-moz-placeholder {\n  font-size: 3.5vw;\n}\n\n.placeholder\\:text-\\[3\\.5vw\\]::placeholder {\n  font-size: 3.5vw;\n}\n\n.focus-within\\:border-black:focus-within {\n  --tw-border-opacity: 1;\n  border-color: rgb(0 0 0 / var(--tw-border-opacity));\n}\n\n.hover\\:bg-gray-50:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(249 250 251 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-neutral-100:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(245 245 245 / var(--tw-bg-opacity));\n}\n\n.focus\\:border-0:focus {\n  border-width: 0px;\n}\n\n.focus\\:outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.focus\\:ring-0:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n}\n\n\n.group:hover .group-hover\\:pointer-events-auto {\n  pointer-events: auto;\n}\n\n.group\\/first:hover .group-hover\\/first\\:pointer-events-auto {\n  pointer-events: auto;\n}\n\n.group\\/second:hover .group-hover\\/second\\:pointer-events-auto {\n  pointer-events: auto;\n}\n\n.group\\/third:hover .group-hover\\/third\\:pointer-events-auto {\n  pointer-events: auto;\n}\n\n.group:hover .group-hover\\:opacity-100 {\n  opacity: 1;\n}\n\n.group\\/first:hover .group-hover\\/first\\:opacity-100 {\n  opacity: 1;\n}\n\n.group\\/second:hover .group-hover\\/second\\:opacity-100 {\n  opacity: 1;\n}\n\n.group\\/third:hover .group-hover\\/third\\:opacity-100 {\n  opacity: 1;\n}\n\n.submenu {\n  display: none;\n}\n\n.submenu.active {\n  display: block;\n  padding-left: 20px;\n}\n\n.submenu-item:hover {\n  background-color: #742626;\n  cursor: pointer;\n}\n\n.submenu {\n  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;\n  opacity: 0;\n  transform: translateY(-10px);\n}\n\n.submenu.active {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.relative {\n  position: relative;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.pointer-events-auto {\n  pointer-events: auto;\n}\n\n.opacity-100 {\n  opacity: 1;\n}\n\n.inline-block {\n  display: inline-block;\n  padding: 0.5vw 1vw;\n}\n\n.hover\\:bg-gray-50:hover {\n  background-color: #d3c3c3;\n}\n\n@media (min-width: 640px) {\n  .sm\\:duration-700 {\n    transition-duration: 700ms;\n  }\n}\n\n\n  .md\\:space-y-\\[\\.35vw\\] > :not([hidden]) ~ :not([hidden]) {\n    --tw-space-y-reverse: 0;\n    margin-top: calc(.35vw * calc(1 - var(--tw-space-y-reverse)));\n    margin-bottom: calc(.35vw * var(--tw-space-y-reverse));\n  }\n\n  .md\\:space-y-\\[1\\.25vw\\] > :not([hidden]) ~ :not([hidden]) {\n    --tw-space-y-reverse: 0;\n    margin-top: calc(1.25vw * calc(1 - var(--tw-space-y-reverse)));\n    margin-bottom: calc(1.25vw * var(--tw-space-y-reverse));\n  }\n\n  .md\\:space-y-\\[1\\.75vw\\] > :not([hidden]) ~ :not([hidden]) {\n    --tw-space-y-reverse: 0;\n    margin-top: calc(1.75vw * calc(1 - var(--tw-space-y-reverse)));\n    margin-bottom: calc(1.75vw * var(--tw-space-y-reverse));\n  }\n\n  .md\\:rounded-\\[\\.5vw\\] {\n    border-radius: .5vw;\n  }\n\n  .md\\:rounded-\\[\\.85vw\\] {\n    border-radius: .85vw;\n  }\n\n  .md\\:rounded-\\[1\\.5vw\\] {\n    border-radius: 1.5vw;\n  }\n\n  .md\\:border-b-\\[1\\.5px\\] {\n    border-bottom-width: 1.5px;\n  }\n\n  .md\\:bg-\\[\\#F7F4FF\\] {\n    --tw-bg-opacity: 1;\n    background-color: rgb(247 244 255 / var(--tw-bg-opacity));\n  }\n\n  .md\\:p-\\[1\\.5vw\\] {\n    padding: 1.5vw;\n  }\n\n  .md\\:p-\\[1vw\\] {\n    padding: 1vw;\n  }\n\n  .md\\:px-0 {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  .md\\:px-\\[\\.75vw\\] {\n    padding-left: .75vw;\n    padding-right: .75vw;\n  }\n\n  .md\\:px-\\[1\\.25vw\\] {\n    padding-left: 1.25vw;\n    padding-right: 1.25vw;\n  }\n\n  .md\\:px-\\[1\\.5vw\\] {\n    padding-left: 1.5vw;\n    padding-right: 1.5vw;\n  }\n\n  .md\\:px-\\[1vw\\] {\n    padding-left: 1vw;\n    padding-right: 1vw;\n  }\n\n  .md\\:px-\\[2\\.5vw\\] {\n    padding-left: 2.5vw;\n    padding-right: 2.5vw;\n  }\n\n  .md\\:px-\\[2vw\\] {\n    padding-left: 2vw;\n    padding-right: 2vw;\n  }\n\n  .md\\:px-\\[3\\.2vw\\] {\n    padding-left: 3.2vw;\n    padding-right: 3.2vw;\n  }\n\n  .md\\:px-\\[5\\.25vw\\] {\n    padding-left: 5.25vw;\n    padding-right: 5.25vw;\n  }\n\n  .md\\:py-\\[\\.2vw\\] {\n    padding-top: .2vw;\n    padding-bottom: .2vw;\n  }\n\n  .md\\:py-\\[\\.65vw\\] {\n    padding-top: .65vw;\n    padding-bottom: .65vw;\n  }\n\n  .md\\:py-\\[\\.75vw\\] {\n    padding-top: .75vw;\n    padding-bottom: .75vw;\n  }\n\n  .md\\:py-\\[1vw\\] {\n    padding-top: 1vw;\n    padding-bottom: 1vw;\n  }\n\n  .md\\:py-\\[2\\.5vw\\] {\n    padding-top: 2.5vw;\n    padding-bottom: 2.5vw;\n  }\n\n  .md\\:py-\\[4\\.5vw\\] {\n    padding-top: 4.5vw;\n    padding-bottom: 4.5vw;\n  }\n\n  .md\\:py-\\[5\\.25vw\\] {\n    padding-top: 5.25vw;\n    padding-bottom: 5.25vw;\n  }\n\n  .md\\:pb-0 {\n    padding-bottom: 0px;\n  }\n\n  .md\\:pb-\\[\\.5vw\\] {\n    padding-bottom: .5vw;\n  }\n\n  .md\\:pb-\\[1\\.5vw\\] {\n    padding-bottom: 1.5vw;\n  }\n\n  .md\\:pb-\\[11vw\\] {\n    padding-bottom: 11vw;\n  }\n\n  .md\\:pb-\\[2\\.25vw\\] {\n    padding-bottom: 2.25vw;\n  }\n\n  .md\\:pb-\\[2vw\\] {\n    padding-bottom: 2vw;\n  }\n\n  .md\\:pb-\\[3\\.5vw\\] {\n    padding-bottom: 3.5vw;\n  }\n\n  .md\\:pb-\\[4vw\\] {\n    padding-bottom: 4vw;\n  }\n\n  .md\\:pb-\\[5vw\\] {\n    padding-bottom: 5vw;\n  }\n\n  .md\\:pb-\\[8vw\\] {\n    padding-bottom: 8vw;\n  }\n\n  .md\\:pl-0 {\n    padding-left: 0px;\n  }\n\n  .md\\:pl-\\[10vw\\] {\n    padding-left: 10vw;\n  }\n\n  .md\\:pl-\\[25vw\\] {\n    padding-left: 25vw;\n  }\n\n  .md\\:pl-\\[3vw\\] {\n    padding-left: 3vw;\n  }\n\n  .md\\:pl-\\[9\\.25vw\\] {\n    padding-left: 9.25vw;\n  }\n\n  .md\\:pr-0 {\n    padding-right: 0px;\n  }\n\n  .md\\:pr-\\[2vw\\] {\n    padding-right: 2vw;\n  }\n\n  .md\\:pr-\\[7vw\\] {\n    padding-right: 7vw;\n  }\n\n  .md\\:pr-\\[8vw\\] {\n    padding-right: 8vw;\n  }\n\n  .md\\:pt-\\[\\.8vw\\] {\n    padding-top: .8vw;\n  }\n\n  .md\\:pt-\\[0vw\\] {\n    padding-top: 0vw;\n  }\n\n  .md\\:pt-\\[1\\.25vw\\] {\n    padding-top: 1.25vw;\n  }\n\n  .md\\:pt-\\[13\\.5vw\\] {\n    padding-top: 13.5vw;\n  }\n\n  .md\\:pt-\\[1vw\\] {\n    padding-top: 1vw;\n  }\n\n  .md\\:pt-\\[2\\.5vw\\] {\n    padding-top: 2.5vw;\n  }\n\n  .md\\:pt-\\[3vw\\] {\n    padding-top: 3vw;\n  }\n\n  .md\\:pt-\\[4\\.5vw\\] {\n    padding-top: 4.5vw;\n  }\n\n  .md\\:pt-\\[5vw\\] {\n    padding-top: 5vw;\n  }\n\n  .md\\:pt-\\[7vw\\] {\n    padding-top: 7vw;\n  }\n\n  .md\\:text-\\[\\.85vw\\] {\n    font-size: .85vw;\n  }\n\n  .md\\:text-\\[\\.8vw\\] {\n    font-size: .8vw;\n  }\n\n  .md\\:text-\\[1\\.01vw\\] {\n    font-size: 1.01vw;\n  }\n\n  .md\\:text-\\[1\\.05vw\\] {\n    font-size: 1.05vw;\n  }\n\n  .md\\:text-\\[1\\.15vw\\] {\n    font-size: 1.15vw;\n  }\n\n  .md\\:text-\\[1\\.1vw\\] {\n    font-size: 1.1vw;\n  }\n\n  .md\\:text-\\[1\\.235vw\\] {\n    font-size: 1.235vw;\n  }\n\n  .md\\:text-\\[1\\.2vw\\] {\n    font-size: 1.2vw;\n  }\n\n  .md\\:text-\\[1\\.30vw\\] {\n    font-size: 1.30vw;\n  }\n\n  .md\\:text-\\[1\\.3vw\\] {\n    font-size: 1.3vw;\n  }\n\n  .md\\:text-\\[1\\.55vw\\] {\n    font-size: 1.55vw;\n  }\n\n  .md\\:text-\\[1\\.5vw\\] {\n    font-size: 1.5vw;\n  }\n\n  .md\\:text-\\[1vw\\] {\n    font-size: 1vw;\n  }\n\n  .md\\:text-\\[2\\.5vw\\] {\n    font-size: 2.5vw;\n  }\n\n  .md\\:text-\\[2\\.7vw\\] {\n    font-size: 2.7vw;\n  }\n\n  .md\\:text-\\[3\\.5vw\\] {\n    font-size: 3.5vw;\n  }\n\n  .md\\:text-\\[4\\.5vw\\] {\n    font-size: 4.5vw;\n  }\n\n  .md\\:text-\\[5\\.8vw\\] {\n    font-size: 5.8vw;\n  }\n\n  .md\\:text-\\[5\\.9vw\\] {\n    font-size: 5.9vw;\n  }\n\n  .md\\:text-\\[8\\.15vw\\] {\n    font-size: 8.15vw;\n  }\n\n  .md\\:leading-\\[\\.92\\] {\n    line-height: .92;\n  }\n\n  .md\\:leading-\\[1\\.2\\] {\n    line-height: 1.2;\n  }\n\n  .md\\:leading-\\[1\\.3\\] {\n    line-height: 1.3;\n  }\n\n  .md\\:leading-normal {\n    line-height: 1.5;\n  }\n\n  .md\\:placeholder\\:text-\\[1\\.01vw\\]::-moz-placeholder {\n    font-size: 1.01vw;\n  }\n\n  .md\\:placeholder\\:text-\\[1\\.01vw\\]::placeholder {\n    font-size: 1.01vw;\n  }\n\n  .md\\:placeholder\\:text-\\[1\\.235vw\\]::-moz-placeholder {\n    font-size: 1.235vw;\n  }\n\n  .md\\:placeholder\\:text-\\[1\\.235vw\\]::placeholder {\n    font-size: 1.235vw;\n  }\n\n\n@media (min-width: 768px) {\n  .md\\:absolute {\n    position: absolute;\n  }\n\n  .md\\:right-\\[1vw\\] {\n    right: 1vw;\n  }\n\n  .md\\:top-0 {\n    top: 0px;\n  }\n\n  .md\\:top-\\[1vw\\] {\n    top: 1vw;\n  }\n\n  .md\\:my-\\[1vw\\] {\n    margin-top: 1vw;\n    margin-bottom: 1vw;\n  }\n\n  .md\\:my-\\[2vw\\] {\n    margin-top: 2vw;\n    margin-bottom: 2vw;\n  }\n\n  .md\\:mb-\\[\\.9vw\\] {\n    margin-bottom: .9vw;\n  }\n\n  .md\\:mb-\\[1\\.5vw\\] {\n    margin-bottom: 1.5vw;\n  }\n\n  .md\\:mt-0 {\n    margin-top: 0px;\n  }\n\n  .md\\:mt-\\[-6vw\\] {\n    margin-top: -6vw;\n  }\n\n  .md\\:mt-\\[\\.45vw\\] {\n    margin-top: .45vw;\n  }\n\n  .md\\:mt-\\[1vw\\] {\n    margin-top: 1vw;\n  }\n\n  .md\\:mt-\\[2\\.5vw\\] {\n    margin-top: 2.5vw;\n  }\n\n  .md\\:mt-\\[2vw\\] {\n    margin-top: 2vw;\n  }\n\n  .md\\:mt-\\[3vw\\] {\n    margin-top: 3vw;\n  }\n\n  .md\\:mt-\\[4vw\\] {\n    margin-top: 4vw;\n  }\n\n  .md\\:mt-\\[6vw\\] {\n    margin-top: 6vw;\n  }\n\n  .md\\:mt-\\[7vw\\] {\n    margin-top: 7vw;\n  }\n\n  .md\\:mt-auto {\n    margin-top: auto;\n  }\n\n  .md\\:block {\n    display: block;\n  }\n\n  .md\\:inline-block {\n    display: inline-block;\n  }\n\n  .md\\:flex {\n    display: flex;\n  }\n\n  .md\\:hidden {\n    display: none;\n  }\n\n  .md\\:h-\\[\\.18vw\\] {\n    height: .18vw;\n  }\n\n  .md\\:h-\\[1\\.55vw\\] {\n    height: 1.55vw;\n  }\n\n  .md\\:h-\\[1\\.75vw\\] {\n    height: 1.75vw;\n  }\n\n  .md\\:h-\\[2\\.25vw\\] {\n    height: 2.25vw;\n  }\n\n  .md\\:h-\\[2\\.5px\\] {\n    height: 2.5px;\n  }\n\n  .md\\:h-\\[2\\.65vw\\] {\n    height: 2.65vw;\n  }\n\n  .md\\:h-\\[22vw\\] {\n    height: 22vw;\n  }\n\n  .md\\:h-\\[3\\.5vw\\] {\n    height: 3.5vw;\n  }\n\n  .md\\:h-\\[4\\.25vw\\] {\n    height: 4.25vw;\n  }\n\n  .md\\:max-h-\\[35vh\\] {\n    max-height: 35vh;\n  }\n\n  .md\\:w-\\[\\.75vw\\] {\n    width: .75vw;\n  }\n\n  .md\\:w-\\[\\.85vw\\] {\n    width: .85vw;\n  }\n\n  .md\\:w-\\[\\.8vw\\] {\n    width: .8vw;\n  }\n\n  .md\\:w-\\[1\\.05vw\\] {\n    width: 1.05vw;\n  }\n\n  .md\\:w-\\[1\\.25vw\\] {\n    width: 1.25vw;\n  }\n\n  .md\\:w-\\[1\\.45vw\\] {\n    width: 1.45vw;\n  }\n\n  .md\\:w-\\[1\\.5vw\\] {\n    width: 1.5vw;\n  }\n\n  .md\\:w-\\[10\\.8vw\\] {\n    width: 10.8vw;\n  }\n\n  .md\\:w-\\[10vw\\] {\n    width: 10vw;\n  }\n\n  .md\\:w-\\[11\\.5vw\\] {\n    width: 11.5vw;\n  }\n\n  .md\\:w-\\[12vw\\] {\n    width: 12vw;\n  }\n\n  .md\\:w-\\[1vw\\] {\n    width: 1vw;\n  }\n\n  .md\\:w-\\[2\\.75vw\\] {\n    width: 2.75vw;\n  }\n\n  .md\\:w-\\[20\\.5vw\\] {\n    width: 20.5vw;\n  }\n\n  .md\\:w-\\[26vw\\] {\n    width: 26vw;\n  }\n\n  .md\\:w-\\[2vw\\] {\n    width: 2vw;\n  }\n\n  .md\\:w-\\[3\\.5vw\\] {\n    width: 3.5vw;\n  }\n\n  .md\\:w-\\[30\\%\\] {\n    width: 30%;\n  }\n\n  .md\\:w-\\[32vw\\] {\n    width: 32vw;\n  }\n\n  .md\\:w-\\[36\\%\\] {\n    width: 36%;\n  }\n\n  .md\\:w-\\[37vw\\] {\n    width: 37vw;\n  }\n\n  .md\\:w-\\[38\\%\\] {\n    width: 38%;\n  }\n\n  .md\\:w-\\[4\\.25vw\\] {\n    width: 4.25vw;\n  }\n\n  .md\\:w-\\[4\\.75vw\\] {\n    width: 4.75vw;\n  }\n\n  .md\\:w-\\[40\\%\\] {\n    width: 40%;\n  }\n\n  .md\\:w-\\[4vw\\] {\n    width: 4vw;\n  }\n\n  .md\\:w-\\[55\\%\\] {\n    width: 55%;\n  }\n\n  .md\\:w-\\[58\\%\\] {\n    width: 58%;\n  }\n\n  .md\\:w-\\[5vw\\] {\n    width: 5vw;\n  }\n\n  .md\\:w-\\[60\\%\\] {\n    width: 60%;\n  }\n\n  .md\\:w-\\[62\\%\\] {\n    width: 62%;\n  }\n\n  .md\\:w-\\[65\\%\\] {\n    width: 65%;\n  }\n\n  .md\\:w-\\[7\\.25vw\\] {\n    width: 7.25vw;\n  }\n\n  .md\\:w-\\[70\\%\\] {\n    width: 70%;\n  }\n\n  .md\\:w-\\[75\\%\\] {\n    width: 75%;\n  }\n\n  .md\\:w-\\[78\\%\\] {\n    width: 78%;\n  }\n\n  .md\\:w-\\[85\\%\\] {\n    width: 85%;\n  }\n\n  .md\\:w-\\[88\\%\\] {\n    width: 88%;\n  }\n\n  .md\\:w-\\[8vw\\] {\n    width: 8vw;\n  }\n\n  .md\\:-translate-y-\\[15\\%\\] {\n    --tw-translate-y: -15%;\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n\n  .md\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .md\\:flex-row {\n    flex-direction: row;\n  }\n\n  .md\\:items-end {\n    align-items: flex-end;\n  }\n\n  .md\\:justify-between {\n    justify-content: space-between;\n  }\n\n  .md\\:gap-0 {\n    gap: 0px;\n  }\n\n  .md\\:gap-\\[\\.5vw\\] {\n    gap: .5vw;\n  }\n\n  .md\\:gap-\\[\\.75vw\\] {\n    gap: .75vw;\n  }\n\n  .md\\:gap-\\[\\.8vw\\] {\n    gap: .8vw;\n  }\n\n  .md\\:gap-\\[1\\.5vw\\] {\n    gap: 1.5vw;\n  }\n\n  .md\\:gap-\\[1\\.75vw\\] {\n    gap: 1.75vw;\n  }\n\n  .md\\:gap-\\[1\\.85vw\\] {\n    gap: 1.85vw;\n  }\n\n  .md\\:gap-\\[10vw\\] {\n    gap: 10vw;\n  }\n\n  .md\\:gap-\\[1vw\\] {\n    gap: 1vw;\n  }\n\n  .md\\:gap-\\[2vw\\] {\n    gap: 2vw;\n  }\n\n  .md\\:gap-\\[3\\.5vw\\] {\n    gap: 3.5vw;\n  }\n\n  .md\\:space-y-\\[\\.35vw\\] > :not([hidden]) ~ :not([hidden]) {\n    --tw-space-y-reverse: 0;\n    margin-top: calc(.35vw * calc(1 - var(--tw-space-y-reverse)));\n    margin-bottom: calc(.35vw * var(--tw-space-y-reverse));\n  }\n\n  .md\\:space-y-\\[1\\.25vw\\] > :not([hidden]) ~ :not([hidden]) {\n    --tw-space-y-reverse: 0;\n    margin-top: calc(1.25vw * calc(1 - var(--tw-space-y-reverse)));\n    margin-bottom: calc(1.25vw * var(--tw-space-y-reverse));\n  }\n\n  .md\\:space-y-\\[1\\.75vw\\] > :not([hidden]) ~ :not([hidden]) {\n    --tw-space-y-reverse: 0;\n    margin-top: calc(1.75vw * calc(1 - var(--tw-space-y-reverse)));\n    margin-bottom: calc(1.75vw * var(--tw-space-y-reverse));\n  }\n\n  .md\\:rounded-\\[\\.5vw\\] {\n    border-radius: .5vw;\n  }\n\n  .md\\:rounded-\\[\\.85vw\\] {\n    border-radius: .85vw;\n  }\n\n  .md\\:rounded-\\[1\\.5vw\\] {\n    border-radius: 1.5vw;\n  }\n\n  .md\\:border-b-\\[1\\.5px\\] {\n    border-bottom-width: 1.5px;\n  }\n\n  .md\\:bg-\\[\\#F7F4FF\\] {\n    --tw-bg-opacity: 1;\n    background-color: rgb(247 244 255 / var(--tw-bg-opacity));\n  }\n\n  .md\\:p-\\[1\\.5vw\\] {\n    padding: 1.5vw;\n  }\n\n  .md\\:p-\\[1vw\\] {\n    padding: 1vw;\n  }\n\n  .md\\:px-0 {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  .md\\:px-\\[\\.75vw\\] {\n    padding-left: .75vw;\n    padding-right: .75vw;\n  }\n\n  .md\\:px-\\[1\\.25vw\\] {\n    padding-left: 1.25vw;\n    padding-right: 1.25vw;\n  }\n\n  .md\\:px-\\[1\\.5vw\\] {\n    padding-left: 1.5vw;\n    padding-right: 1.5vw;\n  }\n\n  .md\\:px-\\[1vw\\] {\n    padding-left: 1vw;\n    padding-right: 1vw;\n  }\n\n  .md\\:px-\\[2\\.5vw\\] {\n    padding-left: 2.5vw;\n    padding-right: 2.5vw;\n  }\n\n  .md\\:px-\\[2vw\\] {\n    padding-left: 2vw;\n    padding-right: 2vw;\n  }\n\n  .md\\:px-\\[3\\.2vw\\] {\n    padding-left: 3.2vw;\n    padding-right: 3.2vw;\n  }\n\n  .md\\:px-\\[5\\.25vw\\] {\n    padding-left: 5.25vw;\n    padding-right: 5.25vw;\n  }\n\n  .md\\:py-\\[\\.2vw\\] {\n    padding-top: .2vw;\n    padding-bottom: .2vw;\n  }\n\n  .md\\:py-\\[\\.65vw\\] {\n    padding-top: .65vw;\n    padding-bottom: .65vw;\n  }\n\n  .md\\:py-\\[\\.75vw\\] {\n    padding-top: .75vw;\n    padding-bottom: .75vw;\n  }\n\n  .md\\:py-\\[1vw\\] {\n    padding-top: 1vw;\n    padding-bottom: 1vw;\n  }\n\n  .md\\:py-\\[2\\.5vw\\] {\n    padding-top: 2.5vw;\n    padding-bottom: 2.5vw;\n  }\n\n  .md\\:py-\\[4\\.5vw\\] {\n    padding-top: 4.5vw;\n    padding-bottom: 4.5vw;\n  }\n\n  .md\\:py-\\[5\\.25vw\\] {\n    padding-top: 5.25vw;\n    padding-bottom: 5.25vw;\n  }\n\n  .md\\:pb-0 {\n    padding-bottom: 0px;\n  }\n\n  .md\\:pb-\\[\\.5vw\\] {\n    padding-bottom: .5vw;\n  }\n\n  .md\\:pb-\\[1\\.5vw\\] {\n    padding-bottom: 1.5vw;\n  }\n\n  .md\\:pb-\\[11vw\\] {\n    padding-bottom: 11vw;\n  }\n\n  .md\\:pb-\\[19vw\\] {\n    padding-bottom: 19vw;\n  }\n\n  .md\\:pb-\\[2\\.25vw\\] {\n    padding-bottom: 2.25vw;\n  }\n\n  .md\\:pb-\\[2vw\\] {\n    padding-bottom: 2vw;\n  }\n\n  .md\\:pb-\\[3\\.5vw\\] {\n    padding-bottom: 3.5vw;\n  }\n\n  .md\\:pb-\\[4vw\\] {\n    padding-bottom: 4vw;\n  }\n\n  .md\\:pb-\\[5vw\\] {\n    padding-bottom: 5vw;\n  }\n\n  .md\\:pb-\\[8vw\\] {\n    padding-bottom: 8vw;\n  }\n\n  .md\\:pl-0 {\n    padding-left: 0px;\n  }\n\n  .md\\:pl-\\[10vw\\] {\n    padding-left: 10vw;\n  }\n\n  .md\\:pl-\\[25vw\\] {\n    padding-left: 25vw;\n  }\n\n  .md\\:pl-\\[3vw\\] {\n    padding-left: 3vw;\n  }\n\n  .md\\:pl-\\[9\\.25vw\\] {\n    padding-left: 9.25vw;\n  }\n\n  .md\\:pr-0 {\n    padding-right: 0px;\n  }\n\n  .md\\:pr-\\[2vw\\] {\n    padding-right: 2vw;\n  }\n\n  .md\\:pr-\\[7vw\\] {\n    padding-right: 7vw;\n  }\n\n  .md\\:pr-\\[8vw\\] {\n    padding-right: 8vw;\n  }\n\n  .md\\:pt-\\[\\.8vw\\] {\n    padding-top: .8vw;\n  }\n\n  .md\\:pt-\\[0vw\\] {\n    padding-top: 0vw;\n  }\n\n  .md\\:pt-\\[1\\.25vw\\] {\n    padding-top: 1.25vw;\n  }\n\n  .md\\:pt-\\[13\\.5vw\\] {\n    padding-top: 13.5vw;\n  }\n\n  .md\\:pt-\\[1vw\\] {\n    padding-top: 1vw;\n  }\n\n  .md\\:pt-\\[2\\.5vw\\] {\n    padding-top: 2.5vw;\n  }\n\n  .md\\:pt-\\[3vw\\] {\n    padding-top: 3vw;\n  }\n\n  .md\\:pt-\\[4\\.5vw\\] {\n    padding-top: 4.5vw;\n  }\n\n  .md\\:pt-\\[5vw\\] {\n    padding-top: 5vw;\n  }\n\n  .md\\:pt-\\[7vw\\] {\n    padding-top: 7vw;\n  }\n\n  .md\\:text-\\[\\.85vw\\] {\n    font-size: .85vw;\n  }\n\n  .md\\:text-\\[\\.8vw\\] {\n    font-size: .8vw;\n  }\n\n  .md\\:text-\\[1\\.01vw\\] {\n    font-size: 1.01vw;\n  }\n\n  .md\\:text-\\[1\\.05vw\\] {\n    font-size: 1.05vw;\n  }\n\n  .md\\:text-\\[1\\.15vw\\] {\n    font-size: 1.15vw;\n  }\n\n  .md\\:text-\\[1\\.1vw\\] {\n    font-size: 1.1vw;\n  }\n\n  .md\\:text-\\[1\\.235vw\\] {\n    font-size: 1.235vw;\n  }\n\n  .md\\:text-\\[1\\.2vw\\] {\n    font-size: 1.2vw;\n  }\n\n  .md\\:text-\\[1\\.30vw\\] {\n    font-size: 1.30vw;\n  }\n\n  .md\\:text-\\[1\\.3vw\\] {\n    font-size: 1.3vw;\n  }\n\n  .md\\:text-\\[1\\.55vw\\] {\n    font-size: 1.55vw;\n  }\n\n  .md\\:text-\\[1\\.5vw\\] {\n    font-size: 1.5vw;\n  }\n\n  .md\\:text-\\[1vw\\] {\n    font-size: 1vw;\n  }\n\n  .md\\:text-\\[2\\.5vw\\] {\n    font-size: 2.5vw;\n  }\n\n  .md\\:text-\\[2\\.7vw\\] {\n    font-size: 2.7vw;\n  }\n\n  .md\\:text-\\[3\\.5vw\\] {\n    font-size: 3.5vw;\n  }\n\n  .md\\:text-\\[3vw\\] {\n    font-size: 3vw;\n  }\n\n  .md\\:text-\\[4\\.5vw\\] {\n    font-size: 4.5vw;\n  }\n\n  .md\\:text-\\[5\\.8vw\\] {\n    font-size: 5.8vw;\n  }\n\n  .md\\:text-\\[5\\.9vw\\] {\n    font-size: 5.9vw;\n  }\n\n  .md\\:text-\\[8\\.15vw\\] {\n    font-size: 8.15vw;\n  }\n\n  .md\\:leading-\\[\\.92\\] {\n    line-height: .92;\n  }\n\n  .md\\:leading-\\[1\\.2\\] {\n    line-height: 1.2;\n  }\n\n  .md\\:leading-\\[1\\.3\\] {\n    line-height: 1.3;\n  }\n\n  .md\\:leading-normal {\n    line-height: 1.5;\n  }\n\n  .md\\:placeholder\\:text-\\[1\\.01vw\\]::-moz-placeholder {\n    font-size: 1.01vw;\n  }\n\n  .md\\:placeholder\\:text-\\[1\\.01vw\\]::placeholder {\n    font-size: 1.01vw;\n  }\n\n  .md\\:placeholder\\:text-\\[1\\.235vw\\]::-moz-placeholder {\n    font-size: 1.235vw;\n  }\n\n  .md\\:placeholder\\:text-\\[1\\.235vw\\]::placeholder {\n    font-size: 1.235vw;\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:max-h-\\[90vh\\] {\n    max-height: 90vh;\n  }\n\n  .lg\\:min-h-screen {\n    min-height: 100vh;\n  }\n\n  .lg\\:pb-\\[12vw\\] {\n    padding-bottom: 12vw;\n  }\n}\n\n.pb-\\[3vw\\] {\n  padding-bottom: 3vw;\n}\n.bg-\\[\\#F7F7F7\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(247 247 247 / var(--tw-bg-opacity));\n}\n.overflow-y-scroll {\n  overflow-y: scroll;\n}\n\n.sticky {\n  position: sticky;\n}\n.border-\\[\\#090B0A\\]\\/\\[\\.28\\] {\n  border-color: rgb(9 11 10 / .28);\n}\n.border-y {\n  border-top-width: 1px;\n  border-bottom-width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
